"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js"(exports2, module2) {
    "use strict";
    !function(t, e) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports2, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, function(t3, r3) {
            return r3 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k = _.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/customParseFormat.js
var require_customParseFormat = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/customParseFormat.js"(exports2, module2) {
    "use strict";
    !function(e, t) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = t();
    }(exports2, function() {
      "use strict";
      var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e2) {
        return (e2 = +e2) + (e2 > 68 ? 1900 : 2e3);
      };
      var f = function(e2) {
        return function(t2) {
          this[e2] = +t2;
        };
      }, h = [/[+-]\d\d:?(\d\d)?|Z/, function(e2) {
        (this.zone || (this.zone = {})).offset = function(e3) {
          if (!e3) return 0;
          if ("Z" === e3) return 0;
          var t2 = e3.match(/([+-]|\d\d)/g), n2 = 60 * t2[1] + (+t2[2] || 0);
          return 0 === n2 ? 0 : "+" === t2[0] ? -n2 : n2;
        }(e2);
      }], u = function(e2) {
        var t2 = s[e2];
        return t2 && (t2.indexOf ? t2 : t2.s.concat(t2.f));
      }, d = function(e2, t2) {
        var n2, r2 = s.meridiem;
        if (r2) {
          for (var i2 = 1; i2 <= 24; i2 += 1) if (e2.indexOf(r2(i2, 0, t2)) > -1) {
            n2 = i2 > 12;
            break;
          }
        } else n2 = e2 === (t2 ? "pm" : "PM");
        return n2;
      }, c = { A: [o, function(e2) {
        this.afternoon = d(e2, false);
      }], a: [o, function(e2) {
        this.afternoon = d(e2, true);
      }], Q: [n, function(e2) {
        this.month = 3 * (e2 - 1) + 1;
      }], S: [n, function(e2) {
        this.milliseconds = 100 * +e2;
      }], SS: [r, function(e2) {
        this.milliseconds = 10 * +e2;
      }], SSS: [/\d{3}/, function(e2) {
        this.milliseconds = +e2;
      }], s: [i, f("seconds")], ss: [i, f("seconds")], m: [i, f("minutes")], mm: [i, f("minutes")], H: [i, f("hours")], h: [i, f("hours")], HH: [i, f("hours")], hh: [i, f("hours")], D: [i, f("day")], DD: [r, f("day")], Do: [o, function(e2) {
        var t2 = s.ordinal, n2 = e2.match(/\d+/);
        if (this.day = n2[0], t2) for (var r2 = 1; r2 <= 31; r2 += 1) t2(r2).replace(/\[|\]/g, "") === e2 && (this.day = r2);
      }], w: [i, f("week")], ww: [r, f("week")], M: [i, f("month")], MM: [r, f("month")], MMM: [o, function(e2) {
        var t2 = u("months"), n2 = (u("monthsShort") || t2.map(function(e3) {
          return e3.slice(0, 3);
        })).indexOf(e2) + 1;
        if (n2 < 1) throw new Error();
        this.month = n2 % 12 || n2;
      }], MMMM: [o, function(e2) {
        var t2 = u("months").indexOf(e2) + 1;
        if (t2 < 1) throw new Error();
        this.month = t2 % 12 || t2;
      }], Y: [/[+-]?\d+/, f("year")], YY: [r, function(e2) {
        this.year = a(e2);
      }], YYYY: [/\d{4}/, f("year")], Z: h, ZZ: h };
      function l(n2) {
        var r2, i2;
        r2 = n2, i2 = s && s.formats;
        for (var o2 = (n2 = r2.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t2, n3, r3) {
          var o3 = r3 && r3.toUpperCase();
          return n3 || i2[r3] || e[r3] || i2[o3].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e2, t3, n4) {
            return t3 || n4.slice(1);
          });
        })).match(t), a2 = o2.length, f2 = 0; f2 < a2; f2 += 1) {
          var h2 = o2[f2], u2 = c[h2], d2 = u2 && u2[0], l2 = u2 && u2[1];
          o2[f2] = l2 ? { regex: d2, parser: l2 } : h2.replace(/^\[|\]$/g, "");
        }
        return function(e2) {
          for (var t2 = {}, n3 = 0, r3 = 0; n3 < a2; n3 += 1) {
            var i3 = o2[n3];
            if ("string" == typeof i3) r3 += i3.length;
            else {
              var s2 = i3.regex, f3 = i3.parser, h3 = e2.slice(r3), u3 = s2.exec(h3)[0];
              f3.call(t2, u3), e2 = e2.replace(u3, "");
            }
          }
          return function(e3) {
            var t3 = e3.afternoon;
            if (void 0 !== t3) {
              var n4 = e3.hours;
              t3 ? n4 < 12 && (e3.hours += 12) : 12 === n4 && (e3.hours = 0), delete e3.afternoon;
            }
          }(t2), t2;
        };
      }
      return function(e2, t2, n2) {
        n2.p.customParseFormat = true, e2 && e2.parseTwoDigitYear && (a = e2.parseTwoDigitYear);
        var r2 = t2.prototype, i2 = r2.parse;
        r2.parse = function(e3) {
          var t3 = e3.date, r3 = e3.utc, o2 = e3.args;
          this.$u = r3;
          var a2 = o2[1];
          if ("string" == typeof a2) {
            var f2 = true === o2[2], h2 = true === o2[3], u2 = f2 || h2, d2 = o2[2];
            h2 && (d2 = o2[2]), s = this.$locale(), !f2 && d2 && (s = n2.Ls[d2]), this.$d = function(e4, t4, n3, r4) {
              try {
                if (["x", "X"].indexOf(t4) > -1) return new Date(("X" === t4 ? 1e3 : 1) * e4);
                var i3 = l(t4)(e4), o3 = i3.year, s2 = i3.month, a3 = i3.day, f3 = i3.hours, h3 = i3.minutes, u3 = i3.seconds, d3 = i3.milliseconds, c3 = i3.zone, m2 = i3.week, M2 = /* @__PURE__ */ new Date(), Y = a3 || (o3 || s2 ? 1 : M2.getDate()), p = o3 || M2.getFullYear(), v = 0;
                o3 && !s2 || (v = s2 > 0 ? s2 - 1 : M2.getMonth());
                var D, w = f3 || 0, g = h3 || 0, y = u3 || 0, L = d3 || 0;
                return c3 ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c3.offset * 1e3)) : n3 ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m2 && (D = r4(D).week(m2).toDate()), D);
              } catch (e5) {
                return /* @__PURE__ */ new Date("");
              }
            }(t3, a2, r3, n2), this.init(), d2 && true !== d2 && (this.$L = this.locale(d2).$L), u2 && t3 != this.format(a2) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
          } else if (a2 instanceof Array) for (var c2 = a2.length, m = 1; m <= c2; m += 1) {
            o2[1] = a2[m - 1];
            var M = n2.apply(this, o2);
            if (M.isValid()) {
              this.$d = M.$d, this.$L = M.$L, this.init();
              break;
            }
            m === c2 && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else i2.call(this, e3);
        };
      };
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isSameOrAfter.js
var require_isSameOrAfter = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isSameOrAfter.js"(exports2, module2) {
    "use strict";
    !function(e, t) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isSameOrAfter = t();
    }(exports2, function() {
      "use strict";
      return function(e, t) {
        t.prototype.isSameOrAfter = function(e2, t2) {
          return this.isSame(e2, t2) || this.isAfter(e2, t2);
        };
      };
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/utc.js
var require_utc = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/utc.js"(exports2, module2) {
    "use strict";
    !function(t, i) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
    }(exports2, function() {
      "use strict";
      var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
      return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t2) {
          var i2 = { date: t2, utc: true, args: arguments };
          return new f(i2);
        }, u.utc = function(i2) {
          var e2 = n(this.toDate(), { locale: this.$L, utc: true });
          return i2 ? e2.add(this.utcOffset(), t) : e2;
        }, u.local = function() {
          return n(this.toDate(), { locale: this.$L, utc: false });
        };
        var o = u.parse;
        u.parse = function(t2) {
          t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), o.call(this, t2);
        };
        var r = u.init;
        u.init = function() {
          if (this.$u) {
            var t2 = this.$d;
            this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
          } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s2, f2) {
          var n2 = this.$utils().u;
          if (n2(s2)) return this.$u ? 0 : n2(this.$offset) ? a.call(this) : this.$offset;
          if ("string" == typeof s2 && (s2 = function(t2) {
            void 0 === t2 && (t2 = "");
            var s3 = t2.match(i);
            if (!s3) return null;
            var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
            return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
          }(s2), null === s2)) return this;
          var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2, o2 = this;
          if (f2) return o2.$offset = u2, o2.$u = 0 === s2, o2;
          if (0 !== s2) {
            var r2 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (o2 = this.local().add(u2 + r2, t)).$offset = u2, o2.$x.$localOffset = r2;
          } else o2 = this.utc();
          return o2;
        };
        var h = u.format;
        u.format = function(t2) {
          var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i2);
        }, u.valueOf = function() {
          var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t2;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t2) {
          return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t2, i2, e2) {
          if (t2 && this.$u === t2.$u) return c.call(this, t2, i2, e2);
          var s2 = this.local(), f2 = n(t2).local();
          return c.call(s2, f2, i2, e2);
        };
      };
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/timezone.js
var require_timezone = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/timezone.js"(exports2, module2) {
    "use strict";
    !function(t, e) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_timezone = e();
    }(exports2, function() {
      "use strict";
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
      return function(n, i, o) {
        var r, a = function(t2, n2, i2) {
          void 0 === i2 && (i2 = {});
          var o2 = new Date(t2), r2 = function(t3, n3) {
            void 0 === n3 && (n3 = {});
            var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r3 = e[o3];
            return r3 || (r3 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r3), r3;
          }(n2, i2);
          return r2.formatToParts(o2);
        }, u = function(e2, n2) {
          for (var i2 = a(e2, n2), r2 = [], u2 = 0; u2 < i2.length; u2 += 1) {
            var f2 = i2[u2], s2 = f2.type, m = f2.value, c = t[s2];
            c >= 0 && (r2[c] = parseInt(m, 10));
          }
          var d = r2[3], l = 24 === d ? 0 : d, h = r2[0] + "-" + r2[1] + "-" + r2[2] + " " + l + ":" + r2[4] + ":" + r2[5] + ":000", v = +e2;
          return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t2, e2) {
          void 0 === t2 && (t2 = r);
          var n2, i2 = this.utcOffset(), a2 = this.toDate(), u2 = a2.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a2 - new Date(u2)) / 1e3 / 60), s2 = 15 * -Math.round(a2.getTimezoneOffset() / 15) - f2;
          if (!Number(s2)) n2 = this.utcOffset(0, e2);
          else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s2, true), e2) {
            var m = n2.utcOffset();
            n2 = n2.add(i2 - m, "minute");
          }
          return n2.$x.$timezone = t2, n2;
        }, f.offsetName = function(t2) {
          var e2 = this.$x.$timezone || o.tz.guess(), n2 = a(this.valueOf(), e2, { timeZoneName: t2 }).find(function(t3) {
            return "timezonename" === t3.type.toLowerCase();
          });
          return n2 && n2.value;
        };
        var s = f.startOf;
        f.startOf = function(t2, e2) {
          if (!this.$x || !this.$x.$timezone) return s.call(this, t2, e2);
          var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return s.call(n2, t2, e2).tz(this.$x.$timezone, true);
        }, o.tz = function(t2, e2, n2) {
          var i2 = n2 && e2, a2 = n2 || e2 || r, f2 = u(+o(), a2);
          if ("string" != typeof t2) return o(t2).tz(a2);
          var s2 = function(t3, e3, n3) {
            var i3 = t3 - 60 * e3 * 1e3, o2 = u(i3, n3);
            if (e3 === o2) return [i3, e3];
            var r2 = u(i3 -= 60 * (o2 - e3) * 1e3, n3);
            return o2 === r2 ? [i3, o2] : [t3 - 60 * Math.min(o2, r2) * 1e3, Math.max(o2, r2)];
          }(o.utc(t2, i2).valueOf(), f2, a2), m = s2[0], c = s2[1], d = o(m).utcOffset(c);
          return d.$x.$timezone = a2, d;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t2) {
          r = t2;
        };
      };
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isBetween.js
var require_isBetween = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/plugin/isBetween.js"(exports2, module2) {
    "use strict";
    !function(e, i) {
      "object" == typeof exports2 && "undefined" != typeof module2 ? module2.exports = i() : "function" == typeof define && define.amd ? define(i) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isBetween = i();
    }(exports2, function() {
      "use strict";
      return function(e, i, t) {
        i.prototype.isBetween = function(e2, i2, s, f) {
          var n = t(e2), o = t(i2), r = "(" === (f = f || "()")[0], u = ")" === f[1];
          return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
      };
    });
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  HOTKEYS: () => HOTKEYS,
  STORAGE_KEYS: () => STORAGE_KEYS,
  areAllArraysEmpty: () => areAllArraysEmpty,
  areDifferentDates: () => areDifferentDates,
  arrayBufferToBase64: () => arrayBufferToBase64,
  buildQueryUrl: () => buildQueryUrl,
  calculateDuration: () => calculateDuration,
  calculateDurationFromDate: () => calculateDurationFromDate,
  calculateExactAge: () => calculateExactAge,
  calculateProgress: () => calculateProgress,
  calculateWorkingDays: () => calculateWorkingDays,
  calculateWorkingHoursByDay: () => calculateWorkingHoursByDay,
  capitalize: () => capitalize,
  checkIsTempId: () => checkIsTempId,
  clearSidebarClasses: () => clearSidebarClasses,
  combineClasses: () => combineClasses,
  convertFileToUrl: () => convertFileToUrl,
  convertISODateToDateFormat: () => convertISODateToDateFormat,
  convertToPNG: () => convertToPNG,
  convertToPNGBase64: () => convertToPNGBase64,
  convertUrlToFile: () => convertUrlToFile,
  convertVietnameseToEnglish: () => convertVietnameseToEnglish,
  cookieStorage: () => cookieStorage,
  countCharacters: () => countCharacters,
  createCategoryOptions: () => createCategoryOptions,
  createDate: () => createDate,
  createDateWithMonthYear: () => createDateWithMonthYear,
  createSearchParams: () => createSearchParams,
  createSearchQuery: () => createSearchQuery,
  createUniqueTimeKey: () => createUniqueTimeKey,
  daysInMonth: () => daysInMonth,
  detectEdgeBrowserOnWindows: () => detectEdgeBrowserOnWindows,
  formatAddressSuggestions: () => formatAddressSuggestions,
  formatDate: () => formatDate,
  formatDateRange: () => formatDateRange,
  formatDateString: () => formatDateString,
  formatDateStringToMonthYear: () => formatDateStringToMonthYear,
  formatDateStringToTimezone: () => formatDateStringToTimezone,
  formatDateTimeDisplay: () => formatDateTimeDisplay,
  formatDateToFullText: () => formatDateToFullText,
  formatDateToText: () => formatDateToText,
  formatDayMonthYearLabel: () => formatDayMonthYearLabel,
  formatDayString: () => formatDayString,
  formatDisplayValue: () => formatDisplayValue,
  formatHoursToDaysAndHours: () => formatHoursToDaysAndHours,
  formatISODateString: () => formatISODateString,
  formatMonthDayWithTimezone: () => formatMonthDayWithTimezone,
  formatMonthYearDisplay: () => formatMonthYearDisplay,
  formatOrdinal: () => formatOrdinal,
  formatPhoneNumber: () => formatPhoneNumber,
  formatTimeString: () => formatTimeString,
  formatTimeStringWithSeconds: () => formatTimeStringWithSeconds,
  generateTempId: () => generateTempId,
  generateUniqueId: () => generateUniqueId,
  generateYearOptions: () => generateYearOptions,
  getAddressAutocompleteIcon: () => getAddressAutocompleteIcon,
  getCategoryItems: () => getCategoryItems,
  getCertificationOrganizationFromMetadata: () => getCertificationOrganizationFromMetadata,
  getCertificationOrganizations: () => getCertificationOrganizations,
  getCurrentYear: () => getCurrentYear,
  getEarliestTimestamp: () => getEarliestTimestamp,
  getErrorTryCatchMessage: () => getErrorTryCatchMessage,
  getFocusPosition: () => getFocusPosition,
  getLayoutElement: () => getLayoutElement,
  getLocalStorage: () => getLocalStorage,
  getMimeTypeFromUrl: () => getMimeTypeFromUrl,
  getNextDate: () => getNextDate,
  getNextMonth: () => getNextMonth,
  getNextYear: () => getNextYear,
  getOrdinalSuffix: () => getOrdinalSuffix,
  getPlainText: () => getPlainText,
  getPreviousMonth: () => getPreviousMonth,
  getPreviousYear: () => getPreviousYear,
  getRandomAvatar: () => getRandomAvatar,
  getSchoolAddressFromMetadata: () => getSchoolAddressFromMetadata,
  getSelectOptions: () => getSelectOptions,
  getSelectedMonth: () => getSelectedMonth,
  getSelectedYear: () => getSelectedYear,
  getSessionItem: () => getSessionItem,
  getTechnicalSkillsFromCategories: () => getTechnicalSkillsFromCategories,
  getWeekdaysInMonth: () => getWeekdaysInMonth,
  getYear: () => getYear,
  handleCertificationNameChange: () => handleCertificationNameChange,
  handleKeyboardShortcuts: () => handleKeyboardShortcuts,
  hasAnyValidValue: () => hasAnyValidValue,
  hasCategoryData: () => hasCategoryData,
  hasCertificationOrganization: () => hasCertificationOrganization,
  hasProperty: () => hasProperty,
  hasSchoolAddress: () => hasSchoolAddress,
  hasValidCertification: () => hasValidCertification,
  hasValidEducation: () => hasValidEducation,
  initHeroCanvas: () => initHeroCanvas,
  initSplashSection: () => initSplashSection,
  isArray: () => isArray,
  isBeforeStartYear: () => isBeforeStartYear,
  isBlockActive: () => isBlockActive,
  isCurrentYearOrBeyond: () => isCurrentYearOrBeyond,
  isDateAfter: () => isDateAfter,
  isEditorEmpty: () => isEditorEmpty,
  isEmptyValueArray: () => isEmptyValueArray,
  isEqual: () => isEqual,
  isMarkActive: () => isMarkActive,
  isSearchTermValid: () => isSearchTermValid,
  isStorageAvailable: () => isStorageAvailable,
  isValidCertification: () => isValidCertification,
  isValidEducation: () => isValidEducation,
  isWeekday: () => isWeekday,
  normalizeAddressData: () => normalizeAddressData,
  normalizeAlphanumericOnly: () => normalizeAlphanumericOnly,
  normalizeHTML: () => normalizeHTML,
  normalizePhoneInput: () => normalizePhoneInput,
  normalizeSearchValue: () => normalizeSearchValue,
  normalizeText: () => normalizeText,
  omitProperties: () => omitProperties,
  parseCertificationDataToStore: () => parseCertificationDataToStore,
  parseDateString: () => parseDateString,
  parseDateStringToDate: () => parseDateStringToDate,
  parseEducationDataToStore: () => parseEducationDataToStore,
  parseHTMLToSlate: () => parseHTMLToSlate,
  parseJourneyDataToStore: () => parseJourneyDataToStore,
  parseTechnicalSkillsDataToStore: () => parseTechnicalSkillsDataToStore,
  removeLocalStorage: () => removeLocalStorage,
  removeNonDigits: () => removeNonDigits,
  removeSessionItem: () => removeSessionItem,
  renderDateStringToMonthYear: () => renderDateStringToMonthYear,
  resizeImageToMax: () => resizeImageToMax,
  roundToDecimals: () => roundToDecimals,
  serialize: () => serialize,
  setLocalStorage: () => setLocalStorage,
  setSessionItem: () => setSessionItem,
  slugify: () => slugify,
  sortDatesDescending: () => sortDatesDescending,
  sortEventsByTimestamp: () => sortEventsByTimestamp,
  sortNumbers: () => sortNumbers,
  splitFirstWord: () => splitFirstWord,
  suppressConsoleError: () => suppressConsoleError,
  suppressConsoleWarnings: () => suppressConsoleWarnings,
  toPlural: () => toPlural,
  toSnakeCase: () => toSnakeCase,
  toggleBlock: () => toggleBlock,
  toggleMark: () => toggleMark,
  updateResumeProgress: () => updateResumeProgress,
  urlToBase64: () => urlToBase64,
  wrapText: () => wrapText
});
module.exports = __toCommonJS(src_exports);

// src/common.ts
var omitProperties = (obj, keys) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  );
};
var getErrorTryCatchMessage = (error, defaultMessage = "") => {
  if (error instanceof Error) {
    return error.message || defaultMessage;
  }
  if (typeof error === "string") {
    return error;
  }
  return defaultMessage;
};
var detectEdgeBrowserOnWindows = () => {
  if (typeof navigator === "undefined") return;
  const ua = navigator.userAgent;
  const isEdge = /Edg\//.test(ua);
  const isWindows = /Windows/.test(ua);
  return isEdge && isWindows;
};

// src/date.ts
var import_dayjs = __toESM(require_dayjs_min());
var import_customParseFormat = __toESM(require_customParseFormat());
var import_isSameOrAfter = __toESM(require_isSameOrAfter());
var import_utc = __toESM(require_utc());
var import_timezone = __toESM(require_timezone());
var import_isBetween = __toESM(require_isBetween());
var import_constants = require("@shared/constants");
import_dayjs.default.extend(import_customParseFormat.default);
import_dayjs.default.extend(import_isSameOrAfter.default);
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_timezone.default);
import_dayjs.default.extend(import_isBetween.default);
var getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) return "th";
  const lastDigit = day % 10;
  switch (lastDigit) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
var formatDateWithFallback = (dayjsDate, formatString, fallback) => dayjsDate.isValid() ? dayjsDate.format(formatString) : String(fallback ?? "");
var formatDate = (date, format = import_constants.DATE_FORMATS.STANDARD) => formatDateWithFallback((0, import_dayjs.default)(date), format, date);
var parseDateString = (dateStr) => {
  if (!dateStr || dateStr.trim() === "") return;
  const parsedDate = (0, import_dayjs.default)(dateStr, "DD/MM/YYYY", true);
  if (!parsedDate.isValid()) return;
  const resultDate = parsedDate.toDate();
  if (isNaN(resultDate.getTime())) return;
  return resultDate;
};
var areDifferentDates = (startDateStr, endDateStr) => {
  const startDate = parseDateString(startDateStr);
  const endDate = parseDateString(endDateStr);
  return !(0, import_dayjs.default)(startDate).isSame(endDate, "day");
};
var isDateAfter = (startDateStr, endDateStr) => {
  const startDate = parseDateString(startDateStr);
  const endDate = parseDateString(endDateStr);
  if (!startDate || !endDate) return false;
  return startDate > endDate;
};
var formatDateStringToMonthYear = (dateStr, withOrdinal) => {
  const date = parseDateString(dateStr);
  if (!date) return "";
  const format = withOrdinal ? `MMM D[${getOrdinalSuffix((0, import_dayjs.default)(date).date())}], YYYY` : "MMM D, YYYY";
  return (0, import_dayjs.default)(date).format(format);
};
var generateYearOptions = (startYear, endYear) => {
  return Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();
};
var createDateWithMonthYear = (baseDate, month, year) => {
  const monthIndex = typeof month === "string" ? import_constants.MONTHS.indexOf(month) : month;
  const yearNumber = year !== void 0 ? Number(year) : (0, import_dayjs.default)(baseDate).year();
  return (0, import_dayjs.default)(baseDate).month(monthIndex).year(yearNumber).toDate();
};
var formatMonthYearDisplay = (date) => (0, import_dayjs.default)(date).format("MMM, YYYY");
var getSelectOptions = (items) => {
  return items.map((item) => ({
    value: item.toString(),
    label: item.toString()
  }));
};
var convertISODateToDateFormat = (dateString) => {
  if (!dateString) return "";
  const date = (0, import_dayjs.default)(dateString);
  return date.isValid() ? date.format("DD/MM/YYYY") : "";
};
var renderDateStringToMonthYear = (startDate, endDate) => {
  if (!startDate && !endDate) return "";
  let formattedAdmission = "[...]";
  const parsedStartDate = startDate ? parseDateString(startDate) : null;
  if (parsedStartDate) {
    formattedAdmission = (0, import_dayjs.default)(parsedStartDate).format("MMM YYYY");
  }
  const formattedGraduation = !endDate ? "- Present" : endDate ? `- ${(0, import_dayjs.default)(parseDateString(endDate)).format("MMM YYYY")}` : "";
  return `${formattedAdmission} ${formattedGraduation}`.trim();
};
var formatDateToFullText = (dateStr, withOrdinal) => {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("/").map(Number);
  if (!day || !month || !year) return "";
  if (withOrdinal) {
    const suffix = getOrdinalSuffix(day);
    return (0, import_dayjs.default)(new Date(year, month - 1, day)).format(
      `D[${suffix}] MMMM, YYYY`
    );
  }
  return (0, import_dayjs.default)(new Date(year, month - 1, day)).format("D MMMM, YYYY");
};
var formatDateToText = (dateStr, withoutDay = false) => {
  const [day, month, year] = dateStr.split("/").map(Number);
  if (!day || !month || !year) return "";
  const format = withoutDay ? "MMM, YYYY" : "MMM DD, YYYY";
  return (0, import_dayjs.default)(new Date(year, month - 1, day)).format(format);
};
var calculateExactAge = (birthDateStr, formatDate2 = import_constants.DATE_FORMATS.STANDARD) => {
  const today = (0, import_dayjs.default)();
  const birthDate = (0, import_dayjs.default)(birthDateStr, formatDate2, true);
  const yearsDiff = today.year() - birthDate.year();
  const birthdayThisYear = (0, import_dayjs.default)(
    `${birthDate.date()}/${birthDate.month() + 1}/${today.year()}`,
    import_constants.DATE_FORMATS.COMPACT
  );
  const hasBirthdayOccurred = today.isSameOrAfter(birthdayThisYear, "day");
  return hasBirthdayOccurred ? yearsDiff : yearsDiff - 1;
};
var getPreviousMonth = (currentMonth) => {
  return (0, import_dayjs.default)(currentMonth || /* @__PURE__ */ new Date()).subtract(1, "month").toDate();
};
var getNextMonth = (currentMonth) => {
  return (0, import_dayjs.default)(currentMonth || /* @__PURE__ */ new Date()).add(1, "month").toDate();
};
var getPreviousYear = (currentYear) => {
  return (0, import_dayjs.default)(currentYear || /* @__PURE__ */ new Date()).subtract(1, "year").toDate();
};
var getNextYear = (currentYear) => {
  return (0, import_dayjs.default)(currentYear || /* @__PURE__ */ new Date()).add(1, "year").toDate();
};
var getNextDate = (currentDate) => {
  return (0, import_dayjs.default)(
    (currentDate || /* @__PURE__ */ new Date()).setMonth(
      (currentDate || /* @__PURE__ */ new Date()).getMonth() + 1
    )
  ).toDate();
};
var formatDayMonthYearLabel = (dateStr, format = "MMM YYYY") => dateStr ? (0, import_dayjs.default)(dateStr, "DD/MM/YYYY").format(format) : "";
var parseDateStringToDate = (dateString, format = import_constants.DATE_FORMATS.STANDARD, strict = true) => {
  if (!dateString) return void 0;
  const parsedDate = (0, import_dayjs.default)(dateString, format, strict);
  return parsedDate.isValid() ? parsedDate.toDate() : void 0;
};
var formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return "";
  const start = startDate || import_constants.EMPTY_FIELD_VALUE;
  const end = endDate || import_constants.DATE_RANGE_DISPLAY.PRESENT;
  return `${start} - ${end}`;
};
var getCurrentYear = () => {
  return (/* @__PURE__ */ new Date()).getFullYear();
};
var formatDisplayValue = (date, mode) => {
  if (mode === import_constants.DATE_PICKER_MODES.MONTH_YEAR) {
    return formatMonthYearDisplay(date);
  }
  if (mode === import_constants.DATE_PICKER_MODES.DATETIME) {
    return (0, import_dayjs.default)(date).format(import_constants.DATE_FORMATS.DATETIME_DISPLAY);
  }
  return date.toLocaleDateString();
};
var isCurrentYearOrBeyond = (date) => {
  return date ? (0, import_dayjs.default)(date).year() >= getCurrentYear() : true;
};
var isBeforeStartYear = (date, startYear = import_constants.DATE_CONSTANTS.START_YEAR) => {
  return date ? (0, import_dayjs.default)(date).year() <= startYear : false;
};
var getSelectedMonth = (date) => {
  return import_constants.MONTHS[(0, import_dayjs.default)(date).month()] ?? "";
};
var getSelectedYear = (date) => {
  const currentYear = getCurrentYear();
  return date ? (0, import_dayjs.default)(date).year().toString() : currentYear.toString();
};
var getYear = (date) => {
  return (0, import_dayjs.default)(date).year();
};
var formatDayString = (dateStr) => {
  if (!dateStr) return "";
  const day = (0, import_dayjs.default)(dateStr).format("DD MMM, YYYY");
  return day;
};
var formatTimeString = (dateStr) => {
  if (!dateStr) return "";
  const time = (0, import_dayjs.default)(dateStr).format("hh:mm A");
  return time;
};
var formatDateString = (dateStr) => {
  if (!dateStr) return "";
  const date = (0, import_dayjs.default)(dateStr).format("hh:mm A DD/MM/YYYY");
  return date;
};
var formatISODateString = (isoDateStr, format = "hh:mm A DD/MM/YYYY") => {
  if (!isoDateStr) return "";
  const date = import_dayjs.default.utc(isoDateStr);
  return date.isValid() ? date.format(format) : "";
};
var createDate = (value) => new Date(value);
var sortDatesDescending = (dateA, dateB) => {
  const dateAObj = parseDateStringToDate(dateA, "DD/MM/YYYY");
  const dateBObj = parseDateStringToDate(dateB, "DD/MM/YYYY");
  if (!dateAObj || !dateBObj) return 0;
  return dateBObj.getTime() - dateAObj.getTime();
};
var getEarliestTimestamp = (events) => {
  const validTimestamps = events.map((event) => event.occurredAt).filter(Boolean).map((isoString) => new Date(isoString).getTime());
  return validTimestamps.length > 0 ? Math.min(...validTimestamps) : 0;
};
var sortEventsByTimestamp = (events) => events.sort((a, b) => {
  const timestampA = a.occurredAt ? new Date(a.occurredAt).getTime() : 0;
  const timestampB = b.occurredAt ? new Date(b.occurredAt).getTime() : 0;
  return timestampB - timestampA;
});
var formatTimeStringWithSeconds = (dateStr) => {
  if (!dateStr) return "";
  const time = (0, import_dayjs.default)(dateStr).format("hh:mm:ss A");
  return time;
};
var createUniqueTimeKey = (dateStr) => {
  if (!dateStr) return "";
  const date = (0, import_dayjs.default)(dateStr);
  if (!date.isValid()) return "";
  return date.format("hh:mm:ss.SSS A");
};
var roundToDecimals = (value, decimals = 1) => {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
};
var calculateWorkingHoursByDay = (start, end) => {
  const daysMap = /* @__PURE__ */ new Map();
  if (!start || !end) return daysMap;
  const startTime = (0, import_dayjs.default)(start).utcOffset(7);
  const endTime = (0, import_dayjs.default)(end).utcOffset(7);
  if (!startTime.isValid() || !endTime.isValid()) return daysMap;
  if (startTime.isAfter(endTime)) return daysMap;
  const startDate = startTime.startOf("day");
  const endDate = endTime.startOf("day");
  let currentDate = startDate;
  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, "day")) {
    const dayOfWeek = currentDate.day();
    if (!import_constants.WORKING_DAYS.includes(dayOfWeek)) {
      currentDate = currentDate.add(1, "day");
      continue;
    }
    const workingDayStart = currentDate.hour(import_constants.MORNING_START).minute(0);
    const workingDayEnd = currentDate.hour(import_constants.AFTERNOON_END).minute(30);
    const actualStart = currentDate.isSame(startDate, "day") ? startTime : workingDayStart;
    const actualEnd = currentDate.isSame(endDate, "day") ? endTime : workingDayEnd;
    if (actualStart.isAfter(actualEnd)) {
      currentDate = currentDate.add(1, "day");
      continue;
    }
    let dayHours = 0;
    const morningStart = currentDate.hour(import_constants.MORNING_START).minute(0);
    const morningEnd = currentDate.hour(import_constants.MORNING_END).minute(0);
    const morningOverlapStart = actualStart.isAfter(morningStart) ? actualStart : morningStart;
    const morningOverlapEnd = actualEnd.isBefore(morningEnd) ? actualEnd : morningEnd;
    if (morningOverlapStart.isBefore(morningOverlapEnd)) {
      dayHours += morningOverlapEnd.diff(morningOverlapStart, "hour", true);
    }
    const afternoonStart = currentDate.hour(import_constants.AFTERNOON_START).minute(30);
    const afternoonEnd = currentDate.hour(import_constants.AFTERNOON_END).minute(30);
    const afternoonOverlapStart = actualStart.isAfter(afternoonStart) ? actualStart : afternoonStart;
    const afternoonOverlapEnd = actualEnd.isBefore(afternoonEnd) ? actualEnd : afternoonEnd;
    if (afternoonOverlapStart.isBefore(afternoonOverlapEnd)) {
      dayHours += afternoonOverlapEnd.diff(afternoonOverlapStart, "hour", true);
    }
    const roundedHours = roundToDecimals(dayHours, 2);
    if (roundedHours > 0) {
      const dateKey = currentDate.format("YYYY-MM-DD");
      daysMap.set(dateKey, roundedHours);
    }
    currentDate = currentDate.add(1, "day");
  }
  return daysMap;
};
var calculateDuration = (start, end) => {
  const daysMap = calculateWorkingHoursByDay(start, end);
  let totalHours = 0;
  daysMap.forEach((hours) => {
    totalHours += hours;
  });
  return roundToDecimals(totalHours);
};
var formatHoursToDaysAndHours = (totalHours) => {
  const days = Math.floor(totalHours / import_constants.WORKING_HOURS_PER_DAY);
  const remainingHours = totalHours % import_constants.WORKING_HOURS_PER_DAY;
  const dayText = days === 1 ? "day" : "days";
  const hourText = remainingHours === 1 ? "hour" : "hours";
  const roundedHours = roundToDecimals(remainingHours);
  if (days === 0) {
    return `${roundedHours} ${hourText}`;
  }
  if (roundedHours === 0) {
    return `${days} ${dayText}`;
  }
  return `${days} ${dayText}, ${roundedHours} ${hourText}`;
};
var formatMonthDayWithTimezone = (dateStr) => {
  if (!dateStr) return "";
  const date = (0, import_dayjs.default)(dateStr).utcOffset(7);
  if (!date.isValid()) return "";
  return date.format("MMM D");
};
var formatDateStringToTimezone = (dateStr, format = import_constants.DATE_FORMATS.TIME_WITH_DATE) => formatDateWithFallback((0, import_dayjs.default)(dateStr).utcOffset(7), format, dateStr);
var formatDateTimeDisplay = (dateStr, format = import_constants.DATE_FORMATS.AT_TIME_ON_DATE, defaultHour = import_constants.MORNING_START) => {
  if (!dateStr) return "";
  const date = import_dayjs.default.utc(dateStr);
  const normalizedDate = date.isValid() && date.isSame(date.startOf("day")) ? date.hour(defaultHour) : date;
  return formatDateWithFallback(normalizedDate, format, dateStr);
};
var calculateWorkingDays = (start, end) => {
  let workingDays = 0;
  let current = start;
  while (current.isBefore(end) || current.isSame(end, "day")) {
    const dayOfWeek = current.day();
    if (import_constants.WORKING_DAYS.includes(dayOfWeek)) {
      workingDays++;
    }
    current = current.add(1, "day");
  }
  return workingDays;
};
var calculateDurationFromDate = (startDate, endDate = /* @__PURE__ */ new Date()) => {
  const start = (0, import_dayjs.default)(startDate).startOf("day");
  const end = (0, import_dayjs.default)(endDate).startOf("day");
  if (!start.isValid() || !end.isValid()) {
    return "";
  }
  const totalWorkingDays = calculateWorkingDays(start, end);
  return `${totalWorkingDays} ${totalWorkingDays === 1 ? "day" : "days"}`;
};
var isWeekday = (date) => {
  const dayOfWeek = date.day();
  return dayOfWeek !== 0 && dayOfWeek !== 6;
};
var daysInMonth = (month, year) => {
  return (0, import_dayjs.default)().year(year).month(month).daysInMonth();
};
var getWeekdaysInMonth = (month, year) => {
  const days = daysInMonth(month, year);
  let weekdays = 0;
  for (let i = 1; i <= days; i++) {
    const date = (0, import_dayjs.default)().year(year).month(month).date(i);
    if (isWeekday(date)) {
      weekdays++;
    }
  }
  return weekdays;
};

// src/richTextSerializer.ts
var import_types = require("@shared/types");
var DEFAULT_STYLES = {
  text: {
    code: "bg-slate-100 px-1.5 py-0.5 rounded text-secondary-foreground text-4xs",
    link: "text-info hover:text-info/80 underline transition-colors"
  },
  block: {
    heading1: "text-2xl md:text-3xl xl:text-[28px] font-semibold mb-4",
    heading2: "text-xl md:text-2xl xl:text-3xl font-semibold mb-3",
    blockquote: "border-l-4 border-slate-300 pl-4 italic text-frost-900 my-4",
    codeBlock: "bg-frost-400 p-4 rounded-md text-4xs my-4 whitespace-pre-wrap",
    list: "space-y-1 pl-4 my-4",
    paragraph: "leading-relaxed text-frost-900 mb-1 whitespace-pre-wrap"
  }
};
var CHATBOT_STYLES = {
  text: {
    code: "bg-frost-900 px-1.5 py-0.5 rounded text-white text-4xs",
    link: "text-info hover:text-info/80 underline transition-colors"
  },
  block: {
    heading1: "text-2xl md:text-3xl xl:text-[28px] font-semibold mb-4",
    heading2: "text-xl md:text-2xl xl:text-3xl font-semibold mb-3",
    blockquote: "border-l-4 border-slate-300 pl-4 italic text-frost-900 my-4",
    codeBlock: "bg-frost-900 p-4 rounded-md text-white text-4xs my-4 whitespace-pre-wrap",
    list: "space-y-1 pl-4 my-4",
    paragraph: "leading-relaxed text-frost-900 mb-1 whitespace-pre-wrap"
  }
};
var getStyles = (preset = import_types.RichTextStylePreset.DEFAULT) => {
  switch (preset) {
    case import_types.RichTextStylePreset.CHATBOT:
      return CHATBOT_STYLES;
    default:
      return DEFAULT_STYLES;
  }
};
var escapeHTML = (text) => {
  const htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  return text.replace(
    /[&<>"']/g,
    (char) => htmlEntities[char]
  );
};
var serializeTextNode = (node, options = {}) => {
  const styles = getStyles(options.stylePreset);
  let text = options.escapeHTML ? escapeHTML(node.text) : node.text;
  text = text.replace(/\n/g, "<br>");
  if (node.code) {
    text = `<code class="${styles.text.code}">${text}</code>`;
  }
  if (node.bold) text = `<strong>${text}</strong>`;
  if (node.italic) text = `<em>${text}</em>`;
  if (node.underline) text = `<u>${text}</u>`;
  if ("url" in node && node.url) {
    text = `<a href="${node.url}" class="${styles.text.link}" target="_blank" rel="noopener noreferrer">${text}</a>`;
  }
  return text;
};
var serializeListItems = (items, options = {}) => {
  return items.filter(
    (item) => "type" in item && item.type === import_types.BlockFormat.LIST_ITEM
  ).map((item) => {
    const content = item.children.map(
      (child) => "text" in child ? serializeTextNode(child, options) : ""
    ).join("");
    return `<li class="leading-relaxed text-frost-900">${content}</li>`;
  }).join("");
};
var validateNodes = (nodes) => {
  return Array.isArray(nodes) && nodes.length > 0 && nodes.every((node) => node && typeof node === "object" && "type" in node);
};
var serialize = (nodes, options = { escapeHTML: true }) => {
  if (!validateNodes(nodes)) {
    return { success: false, content: "" };
  }
  const styles = getStyles(options.stylePreset);
  const serializeNode = (node) => {
    const textContent = node.children.filter((child) => "text" in child).map((child) => serializeTextNode(child, options)).join("");
    switch (node.type) {
      case import_types.BlockFormat.HEADING_1:
        return `<h1 class="${styles.block.heading1}">${textContent}</h1>`;
      case import_types.BlockFormat.HEADING_2:
        return `<h2 class="${styles.block.heading2}">${textContent}</h2>`;
      case import_types.BlockFormat.CODE_BLOCK:
        return `<pre class="${styles.block.codeBlock}"><code>${textContent}</code></pre>`;
      case import_types.BlockFormat.BULLETED_LIST:
        return `<ul class="list-disc ${styles.block.list}">${serializeListItems(node.children, options)}</ul>`;
      case import_types.BlockFormat.NUMBERED_LIST:
        return `<ol class="list-decimal ${styles.block.list}">${serializeListItems(node.children, options)}</ol>`;
      case import_types.BlockFormat.LIST_ITEM:
        return "";
      default:
        return `<p class="${styles.block.paragraph}">${textContent || "&nbsp;"}</p>`;
    }
  };
  const renderQuoteLine = (node) => {
    const text = node.children.filter((child) => "text" in child).map((child) => serializeTextNode(child, options)).join("");
    return `<p class="${styles.block.paragraph}">${text || "&nbsp;"}</p>`;
  };
  let html = "";
  let inQuote = false;
  for (const node of nodes) {
    if (node.type === import_types.BlockFormat.BLOCK_QUOTE) {
      if (!inQuote) {
        html += `<blockquote class="${styles.block.blockquote}">`;
        inQuote = true;
      }
      html += renderQuoteLine(node);
    } else {
      if (inQuote) {
        html += "</blockquote>";
        inQuote = false;
      }
      const nodeHtml = serializeNode(node);
      const hasQuoteWrapper = node.wrapper === import_types.BlockFormat.BLOCK_QUOTE;
      html += hasQuoteWrapper ? `<blockquote class="${styles.block.blockquote}">${nodeHtml}</blockquote>` : nodeHtml;
    }
  }
  if (inQuote) html += "</blockquote>";
  return { success: true, content: html };
};
var getPlainText = (html) => {
  if (!html) return "";
  return html.replace(
    /(<(?:p|div|li|h[1-6]|blockquote|pre)\b[^>]*>)\s*&nbsp;\s*(<\/(?:p|div|li|h[1-6]|blockquote|pre)>)/gi,
    "$1$2"
  ).replace(/<br\s*\/?>/gi, "\n").replace(/<\/(?:p|div|li|h[1-6]|blockquote|pre)>/gi, "\n").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\n$/, "");
};
var normalizeHTML = (text) => {
  if (!text) return "";
  return text.replace(/\n/g, "<br>");
};
var parseHTMLToSlate = (html) => {
  if (!html) {
    return [
      {
        type: import_types.BlockFormat.PARAGRAPH,
        children: [{ text: "" }]
      }
    ];
  }
  const normalizedHtml = normalizeHTML(html);
  const parser = new DOMParser();
  const doc = parser.parseFromString(normalizedHtml, "text/html");
  const bodyChildNodes = Array.from(doc.body.childNodes);
  const isPlainTextWithBr = bodyChildNodes.every((node) => {
    if (node.nodeType === Node.TEXT_NODE) return true;
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === "br")
      return true;
    return false;
  });
  if (isPlainTextWithBr && bodyChildNodes.length > 0) {
    const paragraphs = [];
    let currentText = "";
    bodyChildNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        currentText += node.textContent || "";
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === "br") {
        paragraphs.push({
          type: import_types.BlockFormat.PARAGRAPH,
          children: [{ text: currentText }]
        });
        currentText = "";
      }
    });
    paragraphs.push({
      type: import_types.BlockFormat.PARAGRAPH,
      children: [{ text: currentText }]
    });
    return paragraphs;
  }
  const elements = Array.from(doc.body.children).flatMap(
    (element) => convertNodeToSlate(element)
  );
  if (elements.length === 0) {
    return [
      {
        type: import_types.BlockFormat.PARAGRAPH,
        children: [{ text: "" }]
      }
    ];
  }
  return elements;
};
function convertNodeToSlate(node) {
  switch (node.tagName.toLowerCase()) {
    case "h1":
      return [
        {
          type: import_types.BlockFormat.HEADING_1,
          children: parseTextContent(node)
        }
      ];
    case "h2":
      return [
        {
          type: import_types.BlockFormat.HEADING_2,
          children: parseTextContent(node)
        }
      ];
    case "p": {
      const hasBrElements = node.querySelector("br") !== null;
      if (hasBrElements) {
        return splitParagraphByBr(node);
      }
      return [
        {
          type: import_types.BlockFormat.PARAGRAPH,
          children: parseTextContent(node)
        }
      ];
    }
    case "ul":
    case "ol": {
      const listChildren = Array.from(node.children).map(
        (li) => ({
          type: import_types.BlockFormat.LIST_ITEM,
          children: parseTextContent(li)
        })
      );
      if (listChildren.length === 0) {
        listChildren.push({
          type: import_types.BlockFormat.LIST_ITEM,
          children: [{ text: "" }]
        });
      }
      return [
        {
          type: node.tagName.toLowerCase() === "ul" ? import_types.BlockFormat.BULLETED_LIST : import_types.BlockFormat.NUMBERED_LIST,
          children: listChildren
        }
      ];
    }
    case "blockquote": {
      const children = Array.from(node.children);
      if (children.length === 0)
        return [
          { type: import_types.BlockFormat.BLOCK_QUOTE, children: parseTextContent(node) }
        ];
      return children.flatMap((child) => {
        const tag = child.tagName?.toLowerCase();
        if (tag === "p")
          return [
            {
              type: import_types.BlockFormat.BLOCK_QUOTE,
              children: parseTextContent(child)
            }
          ];
        if (tag)
          return convertNodeToSlate(child).map((el) => ({
            ...el,
            wrapper: import_types.BlockFormat.BLOCK_QUOTE
          }));
        return [
          {
            type: import_types.BlockFormat.BLOCK_QUOTE,
            children: [{ text: child.textContent || "" }]
          }
        ];
      });
    }
    case "pre":
      return [
        {
          type: import_types.BlockFormat.CODE_BLOCK,
          children: parseTextContent(node)
        }
      ];
    case "a":
      return [
        {
          type: import_types.BlockFormat.PARAGRAPH,
          children: [
            {
              text: node.textContent || "",
              url: node.getAttribute("href") || ""
            }
          ]
        }
      ];
    default:
      return [
        {
          type: import_types.BlockFormat.PARAGRAPH,
          children: [{ text: node.textContent || "" }]
        }
      ];
  }
}
var splitParagraphByBr = (node) => {
  const paragraphs = [];
  let currentTexts = [];
  const processNode = (childNode, format = {}) => {
    if (childNode.nodeType === Node.TEXT_NODE) {
      const text = childNode.textContent || "";
      if (text) {
        currentTexts.push({ text, ...format });
      }
    } else if (childNode.nodeType === Node.ELEMENT_NODE) {
      const element = childNode;
      if (element.tagName.toLowerCase() === "br") {
        if (currentTexts.length > 0) {
          paragraphs.push({
            type: import_types.BlockFormat.PARAGRAPH,
            children: currentTexts
          });
        } else {
          paragraphs.push({
            type: import_types.BlockFormat.PARAGRAPH,
            children: [{ text: "" }]
          });
        }
        currentTexts = [];
        return;
      }
      const newFormat = { ...format };
      switch (element.tagName.toLowerCase()) {
        case "strong":
        case "b":
          newFormat.bold = true;
          break;
        case "em":
        case "i":
          newFormat.italic = true;
          break;
        case "u":
          newFormat.underline = true;
          break;
        case "code":
          newFormat.code = true;
          break;
        case "a":
          newFormat.url = element.getAttribute("href") || "";
          break;
      }
      if (element.childNodes.length > 0) {
        Array.from(element.childNodes).forEach(
          (child) => processNode(child, newFormat)
        );
      } else {
        currentTexts.push({ text: "", ...newFormat });
      }
    }
  };
  Array.from(node.childNodes).forEach((child) => processNode(child));
  if (currentTexts.length > 0) {
    paragraphs.push({
      type: import_types.BlockFormat.PARAGRAPH,
      children: currentTexts
    });
  }
  if (paragraphs.length === 0) {
    paragraphs.push({
      type: import_types.BlockFormat.PARAGRAPH,
      children: [{ text: "" }]
    });
  }
  return paragraphs;
};
var parseTextContent = (node) => {
  const texts = [];
  const processNode = (childNode, format = {}) => {
    if (childNode.nodeType === Node.TEXT_NODE) {
      let text = childNode.textContent || "";
      if (/^\u00A0+$/.test(text)) {
        text = "";
      }
      if (text) {
        texts.push({ text, ...format });
      }
    } else if (childNode.nodeType === Node.ELEMENT_NODE) {
      const element = childNode;
      const newFormat = { ...format };
      switch (element.tagName.toLowerCase()) {
        case "strong":
        case "b":
          newFormat.bold = true;
          break;
        case "em":
        case "i":
          newFormat.italic = true;
          break;
        case "u":
          newFormat.underline = true;
          break;
        case "code":
          newFormat.code = true;
          break;
        case "a":
          newFormat.url = element.getAttribute("href") || "";
          break;
        case "br":
          texts.push({ text: "\n", ...format });
          return;
      }
      if (element.childNodes.length > 0) {
        Array.from(element.childNodes).forEach(
          (child) => processNode(child, newFormat)
        );
      } else {
        texts.push({ text: "", ...newFormat });
      }
    }
  };
  Array.from(node.childNodes).forEach((child) => processNode(child));
  return texts.length ? texts : [{ text: "" }];
};

// src/className.ts
var import_clsx = require("clsx");
var import_tailwind_merge = require("tailwind-merge");
var combineClasses = (...inputs) => {
  return (0, import_tailwind_merge.twMerge)((0, import_clsx.clsx)(inputs));
};

// src/mapbox.tsx
var import_AddressIcon = __toESM(require("@shared/icons/AddressIcon"));
var import_POIIcon = __toESM(require("@shared/icons/POIIcon"));
var import_LocalityIcon = __toESM(require("@shared/icons/LocalityIcon"));
var import_PlaceIcon = __toESM(require("@shared/icons/PlaceIcon"));
var import_constants2 = require("@shared/constants");
var import_configs = __toESM(require("@shared/configs"));
var import_jsx_runtime = require("react/jsx-runtime");
var normalizeSearchValue = (search) => {
  return search.trim().toLowerCase();
};
var formatAddressSuggestions = (data) => {
  if (!data) return "";
  const { text = "", place_name = "" } = data;
  if (!text) return place_name;
  if (!place_name) return text;
  return `${text}, ${place_name}`;
};
var getAddressAutocompleteIcon = (type) => {
  const addressIcon = {
    address: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_AddressIcon.default, {}),
    poi: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_POIIcon.default, {}),
    locality: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_LocalityIcon.default, {}),
    place: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_PlaceIcon.default, {})
  };
  return addressIcon[type] || /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_POIIcon.default, {});
};
var normalizeAlphanumericOnly = (str) => str.replace(import_constants2.MAPBOX_REGEX.ALPHANUMERIC, "").toLowerCase();
var isSearchTermValid = (search, prevSearch) => {
  return !(normalizeAlphanumericOnly(search) === normalizeAlphanumericOnly(prevSearch) || search.endsWith(" ") || search.length < import_configs.default.MAPBOX_MIN_SEARCH_LENGTH);
};
var convertVietnameseToEnglish = (text) => {
  if (!text) return "";
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\u0111/g, "d").replace(/\u0110/g, "D");
};
var normalizeAddressData = (data) => {
  if (!data) return data;
  return {
    ...data,
    text: convertVietnameseToEnglish(data.text),
    place_name: convertVietnameseToEnglish(data.place_name)
  };
};
var getFocusPosition = (currentIndex, listLength, shouldMoveDown) => {
  const shouldResetFocus = shouldMoveDown ? currentIndex === listLength - 1 : currentIndex === 0;
  return shouldResetFocus ? -1 : shouldMoveDown ? currentIndex + 1 : currentIndex - 1;
};

// ../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist-node/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

// ../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist-node/rng.js
var rnds8 = new Uint8Array(16);
function rng() {
  return crypto.getRandomValues(rnds8);
}

// ../../node_modules/.pnpm/uuid@14.0.0/node_modules/uuid/dist-node/v4.js
function v4(options, buf, offset) {
  if (!buf && !options && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return _v4(options, buf, offset);
}
function _v4(options, buf, offset) {
  options = options || {};
  const rnds = options.random ?? options.rng?.() ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    if (offset < 0 || offset + 16 > buf.length) {
      throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var v4_default = v4;

// src/resume.ts
var import_constants3 = require("@shared/constants");
var import_types2 = require("@shared/types");

// src/array.ts
var isEmptyValueArray = (arr) => {
  if (!arr || arr.length === 0) return true;
  for (const obj of arr) {
    for (const key in obj) {
      if (obj[key]) {
        return false;
      }
    }
  }
  return true;
};
var areAllArraysEmpty = (obj) => Object.values(obj).every((arr) => arr.length === 0);
var isArray = (value) => Array.isArray(value);
var sortNumbers = (arr, order = "asc") => {
  return [...arr].sort((a, b) => order === "asc" ? a - b : b - a);
};

// src/resume.ts
var generateUniqueId = () => v4_default();
var calculateProgress = (completedSteps, totalSteps = Object.keys(import_types2.ResumeStep).length) => {
  if (totalSteps === 0) return 0;
  return Math.min(
    Math.round(completedSteps.length / totalSteps * 100),
    import_constants3.PROGRESS_CONFIG.MAX_VALUE
  );
};
var updateResumeProgress = (state, completedSteps) => {
  state.completedSteps = completedSteps;
  state.progress = calculateProgress(completedSteps);
};
var parseEducationDataToStore = (data) => data.map((edu) => ({
  ...edu,
  id: edu.id || generateUniqueId(),
  major: edu.major || "",
  admission: convertISODateToDateFormat(edu.admission),
  graduation: edu.graduation ? convertISODateToDateFormat(edu.graduation) : "",
  school: edu.school || "",
  address: edu.address || "",
  degree: edu.degree || ""
}));
var parseJourneyDataToStore = (data) => data.map(
  ({ id, address, company, end, projects, start, title }) => ({
    id: id || generateUniqueId(),
    start: convertISODateToDateFormat(start),
    end: end ? convertISODateToDateFormat(end) : "",
    address: address || "",
    company: company || "",
    title: title || "",
    projects: [
      ...isArray(projects) ? projects.map(
        ({ desc, duties, end: end2, name, role, stacks, start: start2, code }) => ({
          id: generateUniqueId(),
          code: code || "",
          name: name || "",
          role: role || "",
          desc: desc || "",
          duties: duties || "",
          stacks: stacks || [],
          start: convertISODateToDateFormat(start2),
          end: end2 ? convertISODateToDateFormat(end2) : ""
        })
      ) : []
    ]
  })
);
var parseTechnicalSkillsDataToStore = (data) => data.map((skill) => ({
  name: skill.name || "",
  items: skill.items || []
}));
var parseCertificationDataToStore = (data) => data.map((cert) => ({
  issue: convertISODateToDateFormat(cert.issue),
  name: cert.name || "",
  org: cert.org || "",
  url: cert.url || ""
}));
var getCategoryItems = (data, categoryName) => {
  if (!data || typeof data !== "object") {
    return [];
  }
  const categoryItems = data[categoryName];
  if (!categoryItems || !Array.isArray(categoryItems)) {
    return [];
  }
  switch (categoryName) {
    case import_constants3.MasterCategoryType.SCHOOLS:
    case import_constants3.MasterCategoryType.JOB_TITLES:
    case import_constants3.MasterCategoryType.CERTIFICATIONS: {
      const itemsWithData = categoryItems;
      return itemsWithData.map((item) => ({
        id: item.name,
        name: item.name,
        metadata: item.data ?? void 0
      }));
    }
    case import_constants3.MasterCategoryType.DEGREES:
    case import_constants3.MasterCategoryType.SOCIAL_LINKS:
    case import_constants3.MasterCategoryType.FIELDS_OF_STUDY: {
      const simpleItems = categoryItems;
      return simpleItems.map((item) => ({
        id: item.name,
        name: item.name,
        metadata: void 0
      }));
    }
    case import_constants3.MasterCategoryType.SKILLS:
    case import_constants3.MasterCategoryType.STACKS: {
      const skillCategories = categoryItems;
      return skillCategories.flatMap(
        (category) => category.items?.map((item) => ({
          id: item.name,
          name: item.name,
          metadata: { category: category.name }
        })) || []
      );
    }
    default:
      return [];
  }
};
var isValidCertification = (certification) => {
  if (!certification) return false;
  const hasName = !!certification.name && certification.name.trim() !== "";
  const hasIssuer = !!certification.org && certification.org.trim() !== "";
  const hasIssueDate = !!certification.issue;
  const hasCredentialUrl = !!certification.url && certification.url.trim() !== "";
  return hasName || hasIssuer || hasIssueDate || hasCredentialUrl;
};
var hasValidCertification = (certifications) => {
  if (!certifications || !isArray(certifications)) {
    return false;
  }
  return certifications.some(
    (certification) => isValidCertification(certification)
  );
};
var isValidEducation = (education) => {
  if (!education) return false;
  return !!(education.school?.trim() || education.degree?.trim() || education.major?.trim() || education.address?.trim() || education.admission?.trim() || education.graduation?.trim());
};
var hasValidEducation = (educations) => {
  if (!educations?.length) return [];
  return educations.filter(isValidEducation);
};
var hasSchoolAddress = (metadata) => {
  return metadata !== null && typeof metadata === "object" && "address" in metadata;
};
var hasCertificationOrganization = (metadata) => {
  return metadata !== null && typeof metadata === "object" && "org" in metadata;
};
var getSchoolAddressFromMetadata = (metadata) => {
  return hasSchoolAddress(metadata) ? metadata.address : void 0;
};
var getCertificationOrganizationFromMetadata = (metadata) => {
  return hasCertificationOrganization(metadata) ? metadata.org : void 0;
};
var handleCertificationNameChange = (certificationNames, newName) => {
  const trimmedName = newName?.trim().toLowerCase();
  const matchedCertification = trimmedName && certificationNames?.find(({ name }) => name.toLowerCase() === trimmedName);
  return matchedCertification ? getCertificationOrganizationFromMetadata(matchedCertification.metadata) || "" : "";
};
var getCertificationOrganizations = (certifications) => {
  const extractedOrganizations = certifications.map(
    (certification) => getCertificationOrganizationFromMetadata(certification.metadata)
  );
  const validOrganizations = extractedOrganizations.filter(
    (organizationName) => Boolean(organizationName?.trim())
  ).map((organizationName) => organizationName.trim());
  const uniqueOrganizations = [...new Set(validOrganizations)];
  return uniqueOrganizations.map((organizationName) => ({
    id: organizationName,
    name: organizationName,
    metadata: void 0
  }));
};
var getTechnicalSkillsFromCategories = (data, categories) => {
  if (!data || !categories.length) {
    return [];
  }
  return data.filter((skill) => {
    const skillCategory = skill.metadata;
    return skillCategory && categories.includes(skillCategory.category);
  });
};
var createCategoryOptions = (categories) => {
  return categories.map((category) => ({
    id: category,
    name: category,
    metadata: void 0
  }));
};
var hasCategoryData = (data, categoryName) => {
  return !!(data?.[categoryName] && Array.isArray(data[categoryName]) && data[categoryName].length > 0);
};

// src/query.ts
var import_constants4 = require("@shared/constants");
var buildQueryUrl = (pathname, queryString) => {
  return `${pathname}${queryString ? `?${queryString}` : ""}`;
};
var createSearchQuery = (searchParams, key, value) => {
  const params = new URLSearchParams(searchParams);
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  return params.toString();
};
var createSearchParams = (params) => {
  if (!params) return "";
  const searchParams = new URLSearchParams();
  searchParams.set("limit", (params.limit || import_constants4.DEFAULT_LIMIT).toString());
  searchParams.set("offset", (params.offset || 0).toString());
  if (params.search) searchParams.set("search", params.search);
  if (params.skill) searchParams.set("skill", params.skill);
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

// src/comparison.ts
var isEqual = (firstValue, secondValue) => {
  if (firstValue === secondValue) return true;
  if (firstValue && secondValue && typeof firstValue === "object" && typeof secondValue === "object") {
    if (firstValue.constructor !== secondValue.constructor) return false;
    let length, index;
    if (Array.isArray(firstValue)) {
      const arrayB = secondValue;
      length = firstValue.length;
      if (length != arrayB.length) return false;
      for (index = length; index-- !== 0; )
        if (!isEqual(firstValue[index], arrayB[index])) return false;
      return true;
    }
    if (firstValue instanceof RegExp && secondValue instanceof RegExp)
      return firstValue.source === secondValue.source && firstValue.flags === secondValue.flags;
    if (firstValue.valueOf !== Object.prototype.valueOf && typeof firstValue.valueOf === "function" && typeof secondValue.valueOf === "function")
      return firstValue.valueOf() === secondValue.valueOf();
    if (firstValue.toString !== Object.prototype.toString && typeof firstValue.toString === "function" && typeof secondValue.toString === "function")
      return firstValue.toString() === secondValue.toString();
    const objectA = firstValue;
    const objectB = secondValue;
    const keys = Object.keys(objectA);
    length = keys.length;
    if (length !== Object.keys(objectB).length) return false;
    for (index = length; index-- !== 0; ) {
      const key = keys[index];
      if (!Object.prototype.hasOwnProperty.call(objectB, key)) return false;
    }
    for (index = length; index-- !== 0; ) {
      const key = keys[index];
      if (!isEqual(objectA[key], objectB[key])) return false;
    }
    return true;
  }
  return firstValue !== firstValue && secondValue !== secondValue;
};

// src/textUtils.ts
var import_constants5 = require("@shared/constants");
var countCharacters = (nodes) => {
  if (!nodes?.length) return 0;
  const countTextNode = (node) => {
    return node.text.length;
  };
  const countListItemNode = (item) => {
    return item.children.reduce((sum, child) => {
      if ("text" in child) {
        return sum + countTextNode(child);
      }
      return sum;
    }, 0);
  };
  const enterCount = nodes.length > 1 ? nodes.length - 1 : 0;
  return enterCount + nodes.reduce((totalCount, node) => {
    if (!node.children?.length) return totalCount;
    switch (node.type) {
      case "bulleted-list":
      case "numbered-list": {
        const listItems = node.children.filter(
          (item) => "type" in item && item.type === "list-item"
        );
        const listItemEnterCount = listItems.length > 1 ? listItems.length - 1 : 0;
        return totalCount + listItemEnterCount + listItems.reduce((listCount, item) => {
          return listCount + countListItemNode(item);
        }, 0);
      }
      default:
        return totalCount + node.children.reduce((nodeCount, child) => {
          if ("text" in child) {
            return nodeCount + countTextNode(child);
          }
          return nodeCount;
        }, 0);
    }
  }, 0);
};
var isEditorEmpty = (nodes) => {
  if (!nodes?.length) return true;
  const hasNonParagraphBlock = nodes.some((node) => node.type !== "paragraph");
  if (hasNonParagraphBlock) return false;
  return countCharacters(nodes) === 0;
};
var removeNonDigits = (value) => value.replace(/\D/g, "");
var splitFirstWord = (text) => {
  const match = text?.match(/^(\S+)\s+(.*)$/);
  if (match) {
    const [, firstWord, rest] = match;
    return { firstWord, rest };
  } else {
    return { firstWord: text?.trim(), rest: "" };
  }
};
var toSnakeCase = (str) => {
  return str.toLowerCase().replace(/[^\w\s]/g, "").trim().replace(/\s+/g, "_");
};
var normalizeText = (text, options) => {
  if (!text) return "";
  const { toLowerCase = false, trim = false } = options;
  let result = text;
  if (toLowerCase) {
    result = result.toLowerCase();
  }
  if (trim) {
    result = result.trim();
  }
  return result;
};
var slugify = (value) => normalizeText(value, { toLowerCase: true }).replace(/\s+/g, "-");
var generateTempId = () => {
  const timestamp = Date.now().toString(36);
  const randomNum = Math.floor(Math.random() * 1e9).toString(36);
  return `temp_${timestamp}-${randomNum}`;
};
var checkIsTempId = (id) => {
  if (!id) return false;
  const regex = /^temp_[0-9a-z]+-[0-9a-z]+$/;
  return regex.test(id);
};
var trimTrailingWhitespace = (line) => line.replace(import_constants5.TEXT_WRAPPING_PATTERNS.TRAILING_SPACES, "");
var trimEachLine = (text) => text.split("\n").map(trimTrailingWhitespace).join("\n");
var keepOriginal = (input) => input;
var wrapText = (text, options = {}) => {
  if (text == null) return text;
  const {
    width = 40,
    indent = import_constants5.UNICODE.ZERO_WIDTH_SPACE,
    newline = "\n" + (options.indent ?? import_constants5.UNICODE.ZERO_WIDTH_SPACE),
    cut = false,
    trim = false,
    escape = keepOriginal,
    breakAfterFirstSpace = false
  } = options;
  if (breakAfterFirstSpace) {
    const lines = text.split("\n").map((line) => {
      const firstSpaceIndex = line.indexOf(" ");
      if (firstSpaceIndex === -1) return line;
      const firstPart = line.slice(0, firstSpaceIndex);
      const remainingPart = line.slice(firstSpaceIndex + 1);
      const wrappedRemaining = wrapText(remainingPart, {
        ...options,
        breakAfterFirstSpace: false
        // Prevent recursive first-space breaking
      });
      return firstPart + newline + (wrappedRemaining?.substring(indent.length) || "");
    });
    const wrappedText2 = indent + lines.join(newline);
    return trim ? trimEachLine(wrappedText2) : wrappedText2;
  }
  const wrappingRegex = cut ? import_constants5.TEXT_WRAPPING_PATTERNS.EXACT_WIDTH(width) : import_constants5.TEXT_WRAPPING_PATTERNS.WORD_BOUNDARY(width);
  const wrappedLines = text.match(wrappingRegex) || [];
  const wrappedText = indent + wrappedLines.map((line) => escape(line.endsWith("\n") ? line.slice(0, -1) : line)).join(newline);
  return trim ? trimEachLine(wrappedText) : wrappedText;
};
var toPlural = (word, count) => {
  if (count === 1) return word;
  if (!word) return "";
  const lower = word.toLowerCase();
  if (import_constants5.PLURALIZATION_REGEX.ES_SUFFIX.test(lower)) {
    return `${word}es`;
  }
  if (import_constants5.PLURALIZATION_REGEX.IES_SUFFIX.test(lower)) {
    return `${word.slice(0, -1)}ies`;
  }
  return `${word}s`;
};

// src/formatters.ts
var formatPhoneNumber = (phoneNumberString, countryCodeLength) => {
  const hasCountryCode = phoneNumberString.trim().startsWith("+");
  let countryCode = "";
  let remainingInput = phoneNumberString;
  if (hasCountryCode) {
    const match = phoneNumberString.match(/^\+(\d+)/);
    if (match?.[1]) {
      const allDigits = match[1];
      let codeLength = countryCodeLength;
      if (codeLength === void 0) {
        if (allDigits.length > 10) {
          codeLength = 2;
        } else {
          codeLength = Math.min(3, allDigits.length);
        }
      }
      countryCode = allDigits.slice(0, codeLength);
      remainingInput = phoneNumberString.substring(1 + codeLength);
    }
  }
  const digits = removeNonDigits(remainingInput);
  if (digits.length === 0) {
    return hasCountryCode ? `+${countryCode}` : "";
  }
  if (hasCountryCode) {
    if (digits.length <= 3) return `+${countryCode} ${digits}`;
    if (digits.length <= 6)
      return `+${countryCode} ${digits.slice(0, 3)} ${digits.slice(3)}`;
    return `+${countryCode} ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
  }
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
};
var normalizePhoneInput = (value) => {
  const digits = removeNonDigits(value);
  const hasPlus = value.trimStart().startsWith("+");
  let rawValue = hasPlus ? `+${digits}` : digits;
  if (rawValue.startsWith("0")) {
    rawValue = `+84${rawValue.slice(1)}`;
  }
  return rawValue;
};
var formatOrdinal = (num) => {
  const n = typeof num === "string" ? parseInt(num, 10) : Math.floor(num);
  if (isNaN(n)) return "";
  const absN = Math.abs(n);
  const lastDigit = absN % 10;
  const lastTwoDigits = absN % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${n}th`;
  }
  switch (lastDigit) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
};
var capitalize = (str) => {
  if (typeof str !== "string" || str.length === 0) return str;
  return str.replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
};

// src/image.ts
var import_constants6 = require("@shared/constants");
var createFileFromBlob = (blob, originalFileName, extension, mimeType) => {
  return new File([blob], originalFileName.replace(/\.[^/.]+$/, extension), {
    type: mimeType
  });
};
var convertToPNG = async (file) => {
  if (!file.type.startsWith("image/")) {
    throw new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.INVALID_FILE_TYPE);
  }
  if (file.size / 1024 <= import_constants6.MAX_FILE_SIZE && file.type !== "image/webp") {
    return file;
  }
  const img = new Image();
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let timeoutId;
  const url = URL.createObjectURL(file);
  const cleanupListeners = () => {
    img.onload = null;
    img.onerror = null;
  };
  try {
    return await new Promise((resolve, reject) => {
      timeoutId = window.setTimeout(() => {
        reject(new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.PROCESSING_TIMEOUT));
      }, 3e4);
      img.onload = () => {
        const maxSize = 400;
        let width = img.width;
        let height = img.height;
        if (width > maxSize || height > maxSize) {
          const ratio = Math.min(maxSize / width, maxSize / height);
          width = Math.floor(width * ratio);
          height = Math.floor(height * ratio);
        }
        if (img.width === 0 || img.height === 0) {
          reject(new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.INVALID_DIMENSIONS));
          return;
        }
        canvas.width = width;
        canvas.height = height;
        if (!ctx) {
          reject(new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.CANVAS_CONTEXT_ERROR));
          return;
        }
        if (file.type === "image/webp" || file.type === "image/png") {
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, width, height);
        }
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (pngBlob) => {
            if (!pngBlob) {
              reject(new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.CONVERSION_ERROR));
              return;
            }
            if (pngBlob.size / 1024 <= import_constants6.MAX_FILE_SIZE) {
              resolve(
                createFileFromBlob(pngBlob, file.name, ".png", "image/png")
              );
            } else {
              canvas.toBlob(
                (jpegBlob) => {
                  if (!jpegBlob) {
                    reject(
                      new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.CONVERSION_ERROR)
                    );
                    return;
                  }
                  resolve(
                    createFileFromBlob(
                      jpegBlob,
                      file.name,
                      ".jpeg",
                      "image/jpeg"
                    )
                  );
                },
                "image/jpeg",
                0.85
                // 85% quality JPEG is usually much smaller than PNG
              );
            }
          },
          "image/png",
          0.7
          // Lower PNG quality
        );
      };
      img.onerror = () => {
        reject(new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.LOAD_ERROR));
      };
      img.src = url;
    });
  } finally {
    window.clearTimeout(timeoutId);
    URL.revokeObjectURL(url);
    cleanupListeners();
  }
};
var urlToBase64PromiseCache = /* @__PURE__ */ new Map();
var urlToBase64 = (url) => {
  if (url.startsWith("data:")) {
    return Promise.resolve(url);
  }
  const cached = urlToBase64PromiseCache.get(url);
  if (cached) return cached;
  const promise = (async () => {
    const detectedMimeType = getMimeTypeFromUrl(url);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        import_constants6.IMAGE_PROCESSING_MESSAGE.FETCH_ERROR(response.statusText)
      );
    }
    const contentType = response.headers.get("Content-Type");
    const arrayBuffer = await response.arrayBuffer();
    return arrayBufferToBase64(arrayBuffer, contentType || detectedMimeType);
  })().catch((error) => {
    urlToBase64PromiseCache.delete(url);
    throw new Error(
      import_constants6.IMAGE_PROCESSING_MESSAGE.URL_TO_BASE64_ERROR(String(error))
    );
  });
  urlToBase64PromiseCache.set(url, promise);
  return promise;
};
var arrayBufferToBase64 = (buffer, mimeType) => {
  try {
    const bytes = new Uint8Array(buffer);
    const chunkSize = 8192;
    let binary = "";
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.slice(i, Math.min(i + chunkSize, bytes.length));
      binary += String.fromCharCode.apply(null, Array.from(chunk));
    }
    const base64Data = window.btoa(binary);
    return `data:${mimeType};base64,${base64Data}`;
  } catch (error) {
    throw new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.ARRAY_BUFFER_ERROR(String(error)));
  }
};
var getMimeTypeFromUrl = (url) => {
  if (!url) return "image/png";
  try {
    const extension = url.split(".").pop()?.toLowerCase();
    if (!extension) return "image/png";
    const mimeTypes = {
      jpg: "image/jpg",
      jpeg: "image/jpeg",
      png: "image/png",
      webp: "image/webp"
    };
    return mimeTypes[extension] || "image/png";
  } catch (error) {
    console.error("Error getting MIME type from URL:", error);
    return "image/png";
  }
};
var convertToPNGBase64 = async (file) => {
  try {
    const convertedFile = await convertToPNG(file);
    const arrayBuffer = await convertedFile.arrayBuffer();
    return arrayBufferToBase64(arrayBuffer, convertedFile.type);
  } catch (error) {
    throw new Error(import_constants6.IMAGE_PROCESSING_MESSAGE.PNG_BASE64_ERROR(String(error)));
  }
};
var resizeImageToMax = (file, maxSize = 1024) => {
  return new Promise((resolve) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const reader = new FileReader();
    reader.onload = () => {
      img.src = reader.result;
    };
    img.onload = () => {
      let { width, height } = img;
      if (width >= maxSize || height >= maxSize) {
        const ratio = Math.min(maxSize / width, maxSize / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }
      canvas.width = width;
      canvas.height = height;
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      const dataUrl = canvas.toDataURL("image/png");
      resolve(dataUrl);
    };
    reader.readAsDataURL(file);
  });
};
var convertUrlToFile = async (url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, { type: mimeType });
};
var convertFileToUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    if (typeof reader.result === "string") {
      resolve(reader.result);
    } else {
      reject(new Error("Failed to convert file to base64"));
    }
  };
  reader.onerror = () => reject(new Error("FileReader error"));
  reader.readAsDataURL(file);
});
var getRandomAvatar = () => {
  const gender = Math.random() < 0.5 ? "men" : "women";
  const index = Math.floor(Math.random() * 100);
  return `https://randomuser.me/api/portraits/${gender}/${index}.jpg`;
};

// src/types.ts
var hasProperty = (obj, property) => obj !== null && typeof obj === "object" && property in obj;

// src/shortcuts.ts
var import_slate = require("slate");
var import_types3 = require("@shared/types");
var LIST_TYPES = [
  import_types3.BlockFormat.NUMBERED_LIST,
  import_types3.BlockFormat.BULLETED_LIST
];
var MARKS_BLOCKED_IN_CODE_BLOCK = [
  import_types3.TextFormat.BOLD,
  import_types3.TextFormat.ITALIC,
  import_types3.TextFormat.UNDERLINE
];
var WRAPPER_TYPES = [
  import_types3.BlockFormat.BLOCK_QUOTE,
  import_types3.BlockFormat.HEADING_1,
  import_types3.BlockFormat.HEADING_2
];
var isWrapperType = (format) => WRAPPER_TYPES.includes(format);
var WRAPPER_TARGETS = {
  [import_types3.BlockFormat.BLOCK_QUOTE]: [
    import_types3.BlockFormat.CODE_BLOCK,
    import_types3.BlockFormat.BULLETED_LIST,
    import_types3.BlockFormat.NUMBERED_LIST
  ],
  [import_types3.BlockFormat.HEADING_1]: [import_types3.BlockFormat.CODE_BLOCK],
  [import_types3.BlockFormat.HEADING_2]: [import_types3.BlockFormat.CODE_BLOCK]
};
var WRAPPABLE_TYPES = [
  import_types3.BlockFormat.CODE_BLOCK,
  import_types3.BlockFormat.BULLETED_LIST,
  import_types3.BlockFormat.NUMBERED_LIST
];
var matchesFormatOrWrapper = (n, format) => n.type === format || isWrapperType(format) && WRAPPABLE_TYPES.includes(n.type) && "wrapper" in n && n.wrapper === format;
var HOTKEYS = {
  "mod+b": import_types3.TextFormat.BOLD,
  "mod+i": import_types3.TextFormat.ITALIC,
  "mod+u": import_types3.TextFormat.UNDERLINE,
  "mod+`": import_types3.TextFormat.CODE,
  "mod+q": import_types3.BlockFormat.BLOCK_QUOTE,
  "mod+l": import_types3.BlockFormat.CODE_BLOCK,
  "mod+1": import_types3.BlockFormat.HEADING_1,
  "mod+2": import_types3.BlockFormat.HEADING_2,
  "mod+3": import_types3.BlockFormat.BULLETED_LIST,
  "mod+4": import_types3.BlockFormat.NUMBERED_LIST
};
var isListType = (format) => LIST_TYPES.includes(format);
var unwrapLists = (editor) => {
  if (!editor.selection) return;
  LIST_TYPES.forEach((listType) => {
    import_slate.Transforms.unwrapNodes(editor, {
      match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === listType,
      split: true
    });
  });
};
var setBlockType = (editor, format, isActive) => {
  const type = isActive ? import_types3.BlockFormat.PARAGRAPH : isListType(format) ? import_types3.BlockFormat.LIST_ITEM : format;
  import_slate.Transforms.setNodes(
    editor,
    { type },
    {
      match: (n) => import_slate.Element.isElement(n) && "type" in n && import_slate.Editor.isBlock(editor, n)
    }
  );
};
var wrapInList = (editor, format, isActive) => {
  if (!editor.selection) return;
  if (isListType(format) && !isActive) {
    const newList = {
      type: format,
      children: [{ text: "" }]
    };
    import_slate.Transforms.wrapNodes(editor, newList, {
      match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === import_types3.BlockFormat.LIST_ITEM
    });
  }
};
var mergeCodeBlocks = (editor) => {
  if (!editor.selection) return;
  const codeBlocks = Array.from(
    import_slate.Editor.nodes(editor, {
      at: editor.selection,
      match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === import_types3.BlockFormat.CODE_BLOCK
    })
  );
  for (let i = codeBlocks.length - 1; i > 0; i--) {
    const entry = codeBlocks[i];
    if (!entry) continue;
    const [, path] = entry;
    import_slate.Transforms.insertText(editor, "\n", {
      at: import_slate.Editor.start(editor, path)
    });
    import_slate.Transforms.mergeNodes(editor, { at: path });
  }
};
var splitBlocksByNewlines = (editor) => {
  if (!editor.selection) return;
  const blocks = Array.from(
    import_slate.Editor.nodes(editor, {
      at: editor.selection,
      match: (n) => import_slate.Element.isElement(n) && "type" in n && import_slate.Editor.isBlock(editor, n)
    })
  ).reverse();
  let selectionAnchorPath = null;
  let selectionFocusPath = null;
  for (const [node, path] of blocks) {
    const fullText = node.children.map((child) => "text" in child ? child.text : "").join("");
    const lines = fullText.split("\n");
    if (lines.length <= 1) continue;
    import_slate.Transforms.removeNodes(editor, { at: path });
    import_slate.Transforms.insertNodes(
      editor,
      lines.map((line) => ({
        type: import_types3.BlockFormat.PARAGRAPH,
        children: [{ text: line }]
      })),
      { at: path }
    );
    selectionAnchorPath = path;
    if (selectionFocusPath === null) {
      const lastSegment = path[path.length - 1] ?? 0;
      selectionFocusPath = [
        ...path.slice(0, -1),
        lastSegment + lines.length - 1
      ];
    }
  }
  if (selectionAnchorPath !== null && selectionFocusPath !== null) {
    try {
      import_slate.Transforms.select(editor, {
        anchor: import_slate.Editor.start(editor, selectionAnchorPath),
        focus: import_slate.Editor.end(editor, selectionFocusPath)
      });
    } catch {
    }
  }
};
var isEveryBlockActive = (editor, format) => {
  const { selection } = editor;
  if (!selection) return false;
  const nodes = Array.from(
    import_slate.Editor.nodes(editor, {
      at: import_slate.Editor.unhangRange(editor, selection),
      match: (n) => import_slate.Element.isElement(n) && "type" in n && import_slate.Editor.isBlock(editor, n)
    })
  );
  if (nodes.length === 0) return false;
  return nodes.every(
    ([node]) => node.type === format || isListType(format) && node.type === import_types3.BlockFormat.LIST_ITEM
  );
};
var toggleBlock = (editor, format) => {
  if (!editor.selection) return;
  if (isWrapperType(format)) {
    const wrapperTarget = WRAPPER_TARGETS[format].find(
      (type) => isBlockActive(editor, type)
    );
    if (wrapperTarget) {
      const hasWrapper = isBlockActive(editor, format);
      import_slate.Transforms.setNodes(
        editor,
        { wrapper: hasWrapper ? void 0 : format },
        {
          match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === wrapperTarget
        }
      );
      return;
    }
    if (format === import_types3.BlockFormat.BLOCK_QUOTE) {
      const newType = isEveryBlockActive(editor, format) ? import_types3.BlockFormat.PARAGRAPH : import_types3.BlockFormat.BLOCK_QUOTE;
      import_slate.Transforms.setNodes(
        editor,
        { type: newType },
        {
          match: (n) => import_slate.Element.isElement(n) && "type" in n && import_slate.Editor.isBlock(editor, n)
        }
      );
      return;
    }
  }
  const isActive = isEveryBlockActive(editor, format);
  const wasCodeBlock = format !== import_types3.BlockFormat.CODE_BLOCK && isBlockActive(editor, import_types3.BlockFormat.CODE_BLOCK);
  const wasBlockQuoteType = !isActive && isBlockActive(editor, import_types3.BlockFormat.BLOCK_QUOTE);
  let savedWrapper;
  if (isActive && (format === import_types3.BlockFormat.CODE_BLOCK || isListType(format))) {
    const [firstWrapped] = import_slate.Editor.nodes(editor, {
      at: editor.selection,
      match: (n) => import_slate.Element.isElement(n) && "type" in n && n.wrapper !== void 0
    });
    if (firstWrapped) savedWrapper = firstWrapped[0].wrapper;
  }
  unwrapLists(editor);
  if (!isActive && isListType(format)) {
    splitBlocksByNewlines(editor);
  }
  setBlockType(editor, format, isActive);
  if (isActive && format === import_types3.BlockFormat.CODE_BLOCK) {
    splitBlocksByNewlines(editor);
  }
  wrapInList(editor, format, isActive);
  if (wasBlockQuoteType) {
    import_slate.Transforms.setNodes(
      editor,
      { wrapper: import_types3.BlockFormat.BLOCK_QUOTE },
      {
        match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === format
      }
    );
  }
  if (format === import_types3.BlockFormat.CODE_BLOCK && !isActive) {
    mergeCodeBlocks(editor);
  }
  if (format === import_types3.BlockFormat.CODE_BLOCK || wasCodeBlock) {
    try {
      for (const [node, path] of import_slate.Node.nodes(editor)) {
        if (import_slate.Element.isElement(node) && "type" in node && node.type === import_types3.BlockFormat.CODE_BLOCK) {
          import_slate.Transforms.unsetNodes(editor, import_types3.TextFormat.CODE, {
            at: path,
            match: (n) => "text" in n && import_types3.TextFormat.CODE in n
          });
        }
      }
    } catch {
    }
  }
  if (isActive && (format === import_types3.BlockFormat.CODE_BLOCK || isListType(format))) {
    import_slate.Transforms.unsetNodes(editor, "wrapper", {
      match: (n) => import_slate.Element.isElement(n) && "type" in n
    });
    if (savedWrapper) {
      import_slate.Transforms.setNodes(
        editor,
        { type: savedWrapper },
        {
          match: (n) => import_slate.Element.isElement(n) && "type" in n && n.type === import_types3.BlockFormat.PARAGRAPH
        }
      );
    }
  }
  if (editor.selection) {
    try {
      import_slate.Editor.leaf(editor, editor.selection.anchor);
      import_slate.Editor.leaf(editor, editor.selection.focus);
    } catch {
      import_slate.Transforms.deselect(editor);
    }
  }
};
var isBlockActive = (editor, format) => {
  const { selection } = editor;
  if (!selection) return false;
  if (!import_slate.Editor.hasPath(editor, selection.anchor.path)) return false;
  try {
    const [match] = import_slate.Editor.nodes(editor, {
      at: import_slate.Editor.unhangRange(editor, selection),
      match: (n) => import_slate.Element.isElement(n) && "type" in n && matchesFormatOrWrapper(n, format)
    });
    return !!match;
  } catch {
    return false;
  }
};
var isMod = (event) => {
  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  return isMac ? event.metaKey : event.ctrlKey;
};
var isHotkey = (combo, event) => {
  if (!event.key) return false;
  const keys = combo.split("+");
  const key = keys[1];
  if (keys[0] === "mod" && !isMod(event)) {
    return false;
  }
  return event.key.toLowerCase() === key?.toLowerCase();
};
var toggleMark = (editor, format) => {
  const inCodeBlock = isBlockActive(editor, import_types3.BlockFormat.CODE_BLOCK);
  if (MARKS_BLOCKED_IN_CODE_BLOCK.includes(format) && inCodeBlock) return;
  if (format === import_types3.TextFormat.CODE && inCodeBlock) {
    toggleBlock(editor, import_types3.BlockFormat.CODE_BLOCK);
  }
  const isActive = isMarkActive(editor, format);
  if (isActive) {
    import_slate.Editor.removeMark(editor, format);
  } else {
    import_slate.Editor.addMark(editor, format, true);
  }
};
var isMarkActive = (editor, format) => {
  const { selection } = editor;
  if (!selection) return false;
  if (!import_slate.Editor.hasPath(editor, selection.anchor.path)) return false;
  if (isBlockActive(editor, import_types3.BlockFormat.CODE_BLOCK)) return false;
  try {
    const marks = import_slate.Editor.marks(editor);
    return !!marks && marks[format] === true;
  } catch {
    return false;
  }
};
var BLOCK_FORMAT_VALUES = new Set(Object.values(import_types3.BlockFormat));
var TEXT_FORMAT_VALUES = new Set(Object.values(import_types3.TextFormat));
var isBlockFormatType = (format) => BLOCK_FORMAT_VALUES.has(format);
var isTextFormatType = (format) => TEXT_FORMAT_VALUES.has(format);
var handleKeyboardShortcuts = (event, editor, options = {}) => {
  for (const hotkey in HOTKEYS) {
    if (!isHotkey(hotkey, event)) continue;
    const format = HOTKEYS[hotkey];
    if (!format) continue;
    if (format === import_types3.TextFormat.CODE && options.disableInlineCode) continue;
    if (format === import_types3.BlockFormat.CODE_BLOCK && options.disableCodeBlock) continue;
    event.preventDefault();
    if (isBlockFormatType(format)) toggleBlock(editor, format);
    else if (isTextFormatType(format)) toggleMark(editor, format);
  }
};

// src/object.ts
var hasAnyValidValue = (obj, excludeProps = []) => {
  for (const key in obj) {
    if (excludeProps.includes(key)) continue;
    const value = obj[key];
    if (value !== null && value !== void 0 && value !== "") {
      if (isArray(value)) {
        if (value.length > 0) {
          return true;
        }
      } else {
        return true;
      }
    }
  }
  return false;
};

// src/storage.ts
var isStorageAvailable = (type) => {
  try {
    const storage = window[type];
    const testKey = "__storage_test__";
    storage.setItem(testKey, testKey);
    storage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
};
var setSessionItem = (key, value) => {
  try {
    if (typeof window === "undefined" || !isStorageAvailable("sessionStorage")) {
      return false;
    }
    window.sessionStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};
var getSessionItem = (key, defaultValue) => {
  try {
    if (typeof window === "undefined" || !isStorageAvailable("sessionStorage")) {
      return defaultValue;
    }
    const item = window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
};
var removeSessionItem = (key) => {
  try {
    if (typeof window === "undefined" || !isStorageAvailable("sessionStorage")) {
      return false;
    }
    window.sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
var STORAGE_KEYS = {
  LAST_CV_BUILDER_ROUTE: "last_cv_builder_route"
};

// src/localStorage.ts
var setLocalStorage = (key, value, expiryInMinutes) => {
  try {
    const item = {
      value,
      expiry: expiryInMinutes ? Date.now() + expiryInMinutes * 60 * 1e3 : null
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error(`Error setting localStorage key "${key}":`, error);
  }
};
var getLocalStorage = (key, defaultValue) => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return defaultValue;
    const item = JSON.parse(itemStr);
    if (item.expiry && Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return defaultValue;
    }
    return item.value;
  } catch (error) {
    console.error(`Error getting localStorage key "${key}":`, error);
    return defaultValue;
  }
};
var removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing localStorage key "${key}":`, error);
  }
};

// src/cookies.ts
var import_js_cookie = __toESM(require("js-cookie"));
var cookieStorage = {
  getItem: (key) => {
    return import_js_cookie.default.get(key) || null;
  },
  setItem: (key, value, options) => {
    import_js_cookie.default.set(key, value, options);
  },
  removeItem: (key, options) => {
    import_js_cookie.default.remove(key, options);
  },
  clearAllItems: (options) => {
    const allCookies = import_js_cookie.default.get();
    Object.keys(allCookies).forEach((cookieName) => {
      import_js_cookie.default.remove(cookieName, options);
    });
  }
};

// src/chat.ts
var import_constants7 = require("@shared/constants");
var getLayoutElement = (className = ".layout-project") => {
  return document.querySelector(className);
};
var clearSidebarClasses = () => {
  const { OPEN, CLOSE } = import_constants7.CHATBOT_SIDEBAR_CLASSES;
  const layoutElement = getLayoutElement();
  layoutElement?.classList.remove(OPEN, CLOSE);
};

// src/logging.ts
var suppressConsoleWarnings = (message) => {
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const shouldSuppress = args.some(
      (arg) => typeof arg === "string" && arg.includes(message)
    );
    if (!shouldSuppress) {
      originalWarn.apply(console, args);
    }
  };
};
var suppressConsoleError = (message) => {
  const originalError = console.error;
  console.error = function(...args) {
    const shouldSuppress = args.some(
      (arg) => typeof arg === "string" && arg.includes(message)
    );
    if (!shouldSuppress) {
      originalError.apply(console, args);
    }
  };
};

// src/heroSectionCanvas.ts
var authEffectsTier = () => {
  if (typeof window === "undefined") return "full";
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
    return "lite";
  }
  const hc = navigator.hardwareConcurrency ?? 8;
  const nav = navigator;
  const mem = nav.deviceMemory;
  const conn = navigator.connection;
  if (conn?.saveData) return "lite";
  if (hc <= 4) return "lite";
  if (mem != null && mem <= 4) return "lite";
  return "full";
};
var getDistanceSq = (p1, p2) => (p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2;
var assignClosestNeighbors = (pts, width, height, k) => {
  const n = pts.length;
  if (n === 0) return;
  const estSpacing = Math.sqrt(width * height / Math.max(n, 1));
  const cellSize = Math.max(48, estSpacing * 1.8);
  const grid = /* @__PURE__ */ new Map();
  for (const p of pts) {
    const key = `${Math.floor(p.originX / cellSize)},${Math.floor(p.originY / cellSize)}`;
    let bucket = grid.get(key);
    if (!bucket) {
      bucket = [];
      grid.set(key, bucket);
    }
    bucket.push(p);
  }
  const collectRing = (cx, cy, ring, out, seen) => {
    if (ring === 0) {
      const key = `${cx},${cy}`;
      const b = grid.get(key);
      if (b) {
        for (const q of b) {
          if (!seen.has(q)) {
            seen.add(q);
            out.push(q);
          }
        }
      }
      return;
    }
    for (let dx = -ring; dx <= ring; dx++) {
      for (let dy = -ring; dy <= ring; dy++) {
        if (Math.abs(dx) !== ring && Math.abs(dy) !== ring) continue;
        const key = `${cx + dx},${cy + dy}`;
        const b = grid.get(key);
        if (!b) continue;
        for (const q of b) {
          if (!seen.has(q)) {
            seen.add(q);
            out.push(q);
          }
        }
      }
    }
  };
  for (const p of pts) {
    const cx = Math.floor(p.originX / cellSize);
    const cy = Math.floor(p.originY / cellSize);
    const candidates = [];
    const seen = /* @__PURE__ */ new Set();
    seen.add(p);
    let ring = 0;
    const maxRing = 12;
    while (candidates.length < Math.min(n - 1, k + 24) && ring <= maxRing) {
      if (ring === 0) collectRing(cx, cy, 0, candidates, seen);
      else collectRing(cx, cy, ring, candidates, seen);
      ring++;
    }
    const scored = candidates.filter((q) => q !== p).map((q) => ({ q, d: getDistanceSq(p, q) })).sort((a, b) => a.d - b.d);
    p.closest = scored.slice(0, k).map((s) => s.q);
  }
};
var initHeroCanvas = () => {
  if (typeof window === "undefined") return;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
    return;
  }
  const canvas = document.getElementById("hero-canvas");
  if (!canvas) return;
  const ctx = canvas.getContext("2d", { alpha: true, desynchronized: true });
  if (!ctx) return;
  const tier = authEffectsTier();
  if (tier === "lite") {
    document.documentElement.classList.add("auth-effects-lite");
  }
  const gridCols = tier === "lite" ? 12 : 20;
  const gridRows = tier === "lite" ? 12 : 20;
  const SHOOTING_STAR_COUNT = tier === "lite" ? 2 : 5;
  const neighboursK = tier === "lite" ? 4 : 5;
  let width = 0;
  let height = 0;
  let points = [];
  let animateHeader = true;
  let rafId = 0;
  const target = { x: -9999, y: -9999 };
  const shootingStars = [];
  const resetShootingStar = (s) => {
    s.x = Math.random() * width;
    s.y = Math.random() * height;
    const angleDeg = Math.random() * 360;
    const angleRad = angleDeg * Math.PI / 180;
    s.speed = 380 + Math.random() * 300;
    s.vx = Math.cos(angleRad) * s.speed;
    s.vy = Math.sin(angleRad) * s.speed;
    s.tailLength = 80 + Math.random() * 120;
    s.radius = 1.5 + Math.random() * 1.5;
    s.opacity = 0;
    s.phase = "wait";
    s.fadeInTime = 0.08 + Math.random() * 0.06;
    s.activeTime = 0.25 + Math.random() * 0.35;
    s.fadeOutTime = 0.12 + Math.random() * 0.08;
    s.waitTime = 2 + Math.random() * 4;
    s.timer = Math.random() * 5;
  };
  const initShootingStars = () => {
    shootingStars.length = 0;
    for (let i = 0; i < SHOOTING_STAR_COUNT; i++) {
      const s = {};
      resetShootingStar(s);
      shootingStars.push(s);
    }
  };
  const updateShootingStar = (s, dt) => {
    const dtS = dt / 1e3;
    s.timer += dtS;
    if (s.phase === "wait") {
      if (s.timer >= s.waitTime) {
        resetShootingStar(s);
        s.phase = "fade-in";
        s.timer = 0;
      }
      return;
    }
    s.x = s.x + s.vx * dtS;
    s.y = s.y + s.vy * dtS;
    if (s.phase === "fade-in") {
      s.opacity = Math.min(1, s.timer / s.fadeInTime);
      if (s.timer >= s.fadeInTime) {
        s.phase = "active";
        s.timer = 0;
      }
    } else if (s.phase === "active") {
      s.opacity = 1;
      if (s.timer >= s.activeTime) {
        s.phase = "fade-out";
        s.timer = 0;
      }
    } else if (s.phase === "fade-out") {
      s.opacity = Math.max(
        0,
        1 - s.timer / s.fadeOutTime
      );
      if (s.timer >= s.fadeOutTime) {
        s.phase = "wait";
        s.timer = 0;
        s.waitTime = 1.2 + Math.random() * 3.5;
      }
    }
  };
  const drawShootingStar = (s) => {
    if (s.phase === "wait" || s.opacity <= 0) return;
    const len = Math.hypot(s.vx, s.vy);
    const ux = s.vx / len;
    const uy = s.vy / len;
    const sx = s.x;
    const sy = s.y;
    const op = s.opacity;
    const tx = sx - ux * s.tailLength;
    const ty = sy - uy * s.tailLength;
    if (tier === "lite") {
      ctx.save();
      ctx.strokeStyle = `rgba(200,235,255,${op * 0.75})`;
      ctx.lineWidth = s.radius * 1.2;
      ctx.lineCap = "round";
      ctx.beginPath();
      ctx.moveTo(tx, ty);
      ctx.lineTo(sx, sy);
      ctx.stroke();
      ctx.fillStyle = `rgba(255,255,255,${op})`;
      ctx.beginPath();
      ctx.arc(sx, sy, s.radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
      return;
    }
    const grad = ctx.createLinearGradient(tx, ty, sx, sy);
    grad.addColorStop(0, `rgba(156,217,249,0)`);
    grad.addColorStop(0.7, `rgba(200,235,255,${op * 0.55})`);
    grad.addColorStop(1, `rgba(255,255,255,${op})`);
    ctx.save();
    ctx.lineWidth = s.radius * 1.4;
    ctx.strokeStyle = grad;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(tx, ty);
    ctx.lineTo(sx, sy);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(sx, sy, s.radius, 0, Math.PI * 2);
    ctx.fillStyle = `rgba(255,255,255,${op})`;
    ctx.fill();
    const glow = ctx.createRadialGradient(
      sx,
      sy,
      0,
      sx,
      sy,
      s.radius * 5
    );
    glow.addColorStop(0, `rgba(156,217,249,${op * 0.5})`);
    glow.addColorStop(1, `rgba(156,217,249,0)`);
    ctx.beginPath();
    ctx.arc(sx, sy, s.radius * 5, 0, Math.PI * 2);
    ctx.fillStyle = glow;
    ctx.fill();
    ctx.restore();
  };
  class Circle {
    constructor(pos, radius) {
      this.pos = pos;
      this.radius = radius;
      this.active = 0;
    }
    draw() {
      if (!this.active) return;
      ctx.beginPath();
      ctx.arc(this.pos.x, this.pos.y, this.radius, 0, 2 * Math.PI, false);
      ctx.fillStyle = `rgba(156,217,249,${this.active})`;
      ctx.fill();
    }
  }
  const initCanvas = () => {
    const parent = canvas.parentElement;
    width = parent?.clientWidth || window.innerWidth;
    height = parent?.clientHeight || window.innerHeight;
    canvas.width = width;
    canvas.height = height;
  };
  const initPoints = () => {
    points = [];
    const cols = gridCols;
    const rows = gridRows;
    const cellW = width / cols;
    const cellH = height / rows;
    let idx = 0;
    for (let col = 0; col < cols; col++) {
      for (let row = 0; row < rows; row++) {
        const px = col * cellW + Math.random() * cellW;
        const py = row * cellH + Math.random() * cellH;
        points.push({
          index: idx++,
          x: px,
          y: py,
          originX: px,
          originY: py,
          active: 0,
          closest: [],
          circle: null,
          tx: px,
          ty: py,
          tweenProgress: 1,
          tweenDuration: 1,
          tweenStartX: px,
          tweenStartY: py
        });
      }
    }
    assignClosestNeighbors(points, width, height, neighboursK);
    for (const p of points) {
      p.circle = new Circle(p, 2 + Math.random() * 2);
      scheduleNextTween(p);
    }
  };
  const scheduleNextTween = (p) => {
    p.tweenStartX = p.x;
    p.tweenStartY = p.y;
    p.tx = p.originX - 50 + Math.random() * 100;
    p.ty = p.originY - 50 + Math.random() * 100;
    p.tweenProgress = 0;
    p.tweenDuration = 1e3 + Math.random() * 1e3;
  };
  const easeInOutCirc = (t) => t < 0.5 ? (1 - Math.sqrt(1 - 4 * t * t)) / 2 : (Math.sqrt(1 - (-2 * t + 2) ** 2) + 1) / 2;
  let lastTime = 0;
  const combinedLineAlpha = (a, b) => a <= 0 && b <= 0 ? 0 : 1 - (1 - a) * (1 - b);
  const drawLines = (p) => {
    for (const neighbour of p.closest) {
      if (p.index >= neighbour.index) continue;
      const lineAlpha = combinedLineAlpha(p.active, neighbour.active);
      if (lineAlpha <= 0) continue;
      ctx.beginPath();
      ctx.moveTo(p.x, p.y);
      ctx.lineTo(neighbour.x, neighbour.y);
      ctx.strokeStyle = `rgba(156,217,249,${lineAlpha})`;
      ctx.stroke();
    }
  };
  const animate = (now) => {
    const rawDt = now - lastTime;
    lastTime = now;
    const dt = Math.min(Math.max(rawDt, 0), 64);
    if (!document.hidden && animateHeader) {
      ctx.clearRect(0, 0, width, height);
      for (const s of shootingStars) {
        updateShootingStar(s, dt);
        drawShootingStar(s);
      }
      for (const p of points) {
        p.tweenProgress = Math.min(1, p.tweenProgress + dt / p.tweenDuration);
        const e = easeInOutCirc(p.tweenProgress);
        p.x = p.tweenStartX + (p.tx - p.tweenStartX) * e;
        p.y = p.tweenStartY + (p.ty - p.tweenStartY) * e;
        if (p.tweenProgress >= 1) scheduleNextTween(p);
        const dist = getDistanceSq(target, p);
        if (dist < 4e3) {
          p.active = 0.3;
          p.circle.active = 0.6;
        } else if (dist < 2e4) {
          p.active = 0.1;
          p.circle.active = 0.3;
        } else if (dist < 4e4) {
          p.active = 0.02;
          p.circle.active = 0.1;
        } else {
          p.active = 0;
          p.circle.active = 0;
        }
        drawLines(p);
        p.circle.draw();
      }
    }
    rafId = requestAnimationFrame(animate);
  };
  const onScroll = () => {
    const scrollY = window.scrollY ?? document.documentElement.scrollTop ?? 0;
    animateHeader = scrollY <= height;
  };
  if (!("ontouchstart" in window)) {
    window.addEventListener(
      "mousemove",
      (e) => {
        target.x = e.pageX;
        target.y = e.pageY;
      },
      { passive: true }
    );
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    initCanvas();
    initPoints();
    initShootingStars();
  });
  initCanvas();
  initPoints();
  initShootingStars();
  rafId = requestAnimationFrame((now) => {
    lastTime = now;
    animate(now);
  });
  const stopLoop = () => cancelAnimationFrame(rafId);
  window.addEventListener("pagehide", stopLoop, { once: true });
  window.addEventListener("pageshow", (ev) => {
    if (ev.persisted) {
      cancelAnimationFrame(rafId);
      lastTime = performance.now();
      rafId = requestAnimationFrame(animate);
    }
  });
};
var initSplashSection = () => {
  const tier = authEffectsTier();
  const LOADING_MS = 1e3;
  const loader = document.getElementById("splash-section");
  const content = document.getElementById("page-content");
  const sloth = document.querySelector(".splash-section-sloth");
  const bar = document.querySelector(".splash-section-bar");
  const track = document.querySelector(".splash-section-track");
  const barFill = document.querySelector(".splash-section-bar-fill");
  if (tier === "lite") {
    document.documentElement.classList.add("auth-effects-lite");
    loader?.classList.add("splash-section--lite");
  }
  const updateTravel = () => {
    if (!track || !bar || !sloth) return;
    const travel = Math.max(
      0,
      bar.clientWidth - sloth.clientWidth
    );
    track.style.setProperty("--sloth-travel", `${travel}px`);
  };
  const startAnimations = () => {
    updateTravel();
    if (loader) loader.style.setProperty("--loading-ms", `${LOADING_MS}ms`);
    loader?.classList.add("splash-section--ready");
  };
  requestAnimationFrame(() => {
    if (!sloth) {
      startAnimations();
      return;
    }
    if (sloth.complete) {
      startAnimations();
    } else {
      sloth.addEventListener("load", startAnimations, { once: true });
    }
  });
  window.addEventListener("resize", updateTravel, { passive: true });
  const done = () => {
    if (content) content.hidden = false;
    if (loader) loader.remove();
    document.body.classList.remove("is-loading");
    document.body.dataset.loading = "false";
    window.removeEventListener("resize", updateTravel);
  };
  const fallback = window.setTimeout(done, LOADING_MS + 250);
  barFill?.addEventListener(
    "animationend",
    () => {
      window.clearTimeout(fallback);
      done();
    },
    { once: true }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  HOTKEYS,
  STORAGE_KEYS,
  areAllArraysEmpty,
  areDifferentDates,
  arrayBufferToBase64,
  buildQueryUrl,
  calculateDuration,
  calculateDurationFromDate,
  calculateExactAge,
  calculateProgress,
  calculateWorkingDays,
  calculateWorkingHoursByDay,
  capitalize,
  checkIsTempId,
  clearSidebarClasses,
  combineClasses,
  convertFileToUrl,
  convertISODateToDateFormat,
  convertToPNG,
  convertToPNGBase64,
  convertUrlToFile,
  convertVietnameseToEnglish,
  cookieStorage,
  countCharacters,
  createCategoryOptions,
  createDate,
  createDateWithMonthYear,
  createSearchParams,
  createSearchQuery,
  createUniqueTimeKey,
  daysInMonth,
  detectEdgeBrowserOnWindows,
  formatAddressSuggestions,
  formatDate,
  formatDateRange,
  formatDateString,
  formatDateStringToMonthYear,
  formatDateStringToTimezone,
  formatDateTimeDisplay,
  formatDateToFullText,
  formatDateToText,
  formatDayMonthYearLabel,
  formatDayString,
  formatDisplayValue,
  formatHoursToDaysAndHours,
  formatISODateString,
  formatMonthDayWithTimezone,
  formatMonthYearDisplay,
  formatOrdinal,
  formatPhoneNumber,
  formatTimeString,
  formatTimeStringWithSeconds,
  generateTempId,
  generateUniqueId,
  generateYearOptions,
  getAddressAutocompleteIcon,
  getCategoryItems,
  getCertificationOrganizationFromMetadata,
  getCertificationOrganizations,
  getCurrentYear,
  getEarliestTimestamp,
  getErrorTryCatchMessage,
  getFocusPosition,
  getLayoutElement,
  getLocalStorage,
  getMimeTypeFromUrl,
  getNextDate,
  getNextMonth,
  getNextYear,
  getOrdinalSuffix,
  getPlainText,
  getPreviousMonth,
  getPreviousYear,
  getRandomAvatar,
  getSchoolAddressFromMetadata,
  getSelectOptions,
  getSelectedMonth,
  getSelectedYear,
  getSessionItem,
  getTechnicalSkillsFromCategories,
  getWeekdaysInMonth,
  getYear,
  handleCertificationNameChange,
  handleKeyboardShortcuts,
  hasAnyValidValue,
  hasCategoryData,
  hasCertificationOrganization,
  hasProperty,
  hasSchoolAddress,
  hasValidCertification,
  hasValidEducation,
  initHeroCanvas,
  initSplashSection,
  isArray,
  isBeforeStartYear,
  isBlockActive,
  isCurrentYearOrBeyond,
  isDateAfter,
  isEditorEmpty,
  isEmptyValueArray,
  isEqual,
  isMarkActive,
  isSearchTermValid,
  isStorageAvailable,
  isValidCertification,
  isValidEducation,
  isWeekday,
  normalizeAddressData,
  normalizeAlphanumericOnly,
  normalizeHTML,
  normalizePhoneInput,
  normalizeSearchValue,
  normalizeText,
  omitProperties,
  parseCertificationDataToStore,
  parseDateString,
  parseDateStringToDate,
  parseEducationDataToStore,
  parseHTMLToSlate,
  parseJourneyDataToStore,
  parseTechnicalSkillsDataToStore,
  removeLocalStorage,
  removeNonDigits,
  removeSessionItem,
  renderDateStringToMonthYear,
  resizeImageToMax,
  roundToDecimals,
  serialize,
  setLocalStorage,
  setSessionItem,
  slugify,
  sortDatesDescending,
  sortEventsByTimestamp,
  sortNumbers,
  splitFirstWord,
  suppressConsoleError,
  suppressConsoleWarnings,
  toPlural,
  toSnakeCase,
  toggleBlock,
  toggleMark,
  updateResumeProgress,
  urlToBase64,
  wrapText
});
